import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import ReactPaginate from "react-paginate";
import mediaImage from './../../../assets/images/user.jpg';
import CalendarIcon from './../../../icons/calendaricon';
import TwitterIcon from './../../../icons/twittericon';
import InstaIcon from './../../../icons/instaicon';
import TextField from './../../../component/TextField';
import CheckBox from './../../../component/CheckBox';
import Dropdown from './../../../component/Dropdown';
import DropdownMaster from './../../../component/DropdownMaster';
import DropdownMasterScreening from './../../../component/DropdownMasterScreening';
import DraggerIcon from './../../../icons/draggericon';
import FpgMinusIcon from './../../../icons/fpgminusicon';
import FpgPlusIcon from './../../../icons/fpgplusicon';
import AddFileIcon from './../../../icons/plusicon';
import CopyIcon from './../../../icons/copyicon';
import AddarrowIcon from './../../../icons/addarrow';
import Select from 'react-select';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ModalMessage from '../../ModalMessage';
import ErrorPopUp from '../../errorPopUp';
import ErrorScreeningPopUp from '../../errorScreeningPopUp';
import Cookies from 'universal-cookie';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import { isEqual, cloneDeep } from 'lodash';
//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../../redux/bindActionCretor'
import { getData } from '../../../functions';
import { resolveFromInitial } from '../../../cosntants';

//import AWS from "aws-sdk";
import AWS from "aws-sdk";

//Service import
import service from '../../../services'

//Validation import 
import SimpleReactValidator from 'simple-react-validator';

//moment import
import moment from "moment-timezone";

//  Date Picker
import DatePicker from "react-datepicker";
import Loader from '../../loader';
import UploadForm from './UploadForm';
import PopUpCustomAll from './popUpCustomAll';
import DeletefileIcon from '../../../icons/DeletefileIcon';
import TextEditor from '../../TextEditor';
import commonImage from '../../../commonImage';
//sweet alert
import swal from 'sweetalert';
import SearchIcon from '../../../icons/searchicon';
import { STORAGE_PATHS } from '../../../cosntants';
import htmlToDraft from 'html-to-draftjs';
import RecordPresenceBanner from '../../RecordPresenceBanner';
import ConflictSaveModal from '../../ConflictSaveModal';

let sub;

const cookies = new Cookies();

const getEmbedUrl = (url) => {
    if (!url) return '';
    if (url.includes('youtube.com/embed/') || url.includes('player.vimeo.com/video/')) return url;
    const ytMatch = url.match(/(?:youtube\.com\/watch\?[^#]*v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
    if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`;
    const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
    return url;
};

// fake data generator
const getItems = (count) =>
    Array.from({ length: count }, (v, k) => k).map((k) => ({
        id: `item-${k}`,
        content: `item ${k}`,
    }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};
const mapStateToProps = state => ({
    filmEditId: state.filmEditId,
    recordViewers: state.recordViewers,
    recordConflict: state.recordConflict,
    getLoginAdminByID: state.getLoginAdminByID,
    allInitial: state.allInitial,
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

class CreateFilmtab extends Component {
    constructor(props) {
        super(props)

        this._hasLeftPresence = false;

        this.state = {
            Locationisset: [],
            showConflictModal: false,
            editStartVersion: null,
            inPersonArray: [
                {
                    value: "inperson",
                    name: "In-Person"
                },
                {
                    value: "Online",
                    name: "Online"
                }
            ],
            locationArray: [
                {
                    label: "Premiere",
                    value: "Premiere",
                },
                {
                    label: "Second Screening",
                    value: "SecondScreening"
                },
                {
                    label: "Award Winner",
                    value: "AwardWinner"
                }],
            locationStatus: false,
            InpersonDropdownVal: [{
                _id: Math.random(),
                inperId: '',
                InperType: [{
                    _id: Math.random(),
                    InperInsideType: ''
                }]
            }],
            selectedLocation: null,
            sponsorLogoDetails: false,
            awardSponsorLogoDetails: false,
            screeninfpopup: false,
            screeninfpopupPre: false,
            sponserlogo: false,
            deleteImageId: '',
            deleteImagePopup: false,
            filmDisabled: false,
            isDraggable: false,
            isFilmEdited: false,
            initialData: null,
            meetImagePreloader: false,
            maxWaitListSlots:0,
            waitListSlotValid:'',
            screeningType: [
                { _id: '1', name: 'Premiere' },
                { _id: '2', name: 'Second Screening' },
                { _id: '3', name: 'Award winner' }
            ],
            locationType: [
                { _id: '1', name: 'In-Person' },
                { _id: '2', name: 'Online' },
            ],
            locationType1: [
                { _id: '2', name: 'Online' },
            ],
            isMyLibraryScreen:false,
            locations: [],
            shortDateTime: [],
            dropDownRemoveForIndiesSeries: false,
            errorPopup: false,
            errorScreeningPopup: false,
            errorData: [],
            discardPopup: false,
            errorMsg: '',
            imageErr: '',
            file: null,
            filmId: this.props.filmEditId,
            film: this.props.film,
            selectedOption: null,
            hours: '7',
            minutes: '30',
            state: 'AM',
            publishModal: false,
            optiondata: ["Alberta", "British", "Manitoba", "Executive Producers", "Newfoundland"],
            previewRecordFilm: [],
            countryType: ["Select Country", "United States", "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "The Democratic Republic of Congo", "Cook Islands", "Costa Rica", "Ivory Coast", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "England", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji Islands", "Finland", "France", "French Guiana", "French Polynesia", "French Southern territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Isle of Man", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova", "Monaco", "Mongolia", "Montserrat", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "North Macedonia", "North Korea", "Northern Ireland", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Scotland", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Korea", "South Sudan", "Spain", "SriLanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syria", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wales", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe",],
            shortFlim: false,
            indiesFlim: false,
            shortProgramme45: {
                name: '',
            },
            shortProgramme1: '',
            shortProgramme: '',
            shortProgrammeDrop: '',
            fileMakerId: "",
            access: "",
            title: "",
            article: '',
            description: EditorState.createEmpty(),
            shortDescription: EditorState.createEmpty(),
            company: '',
            credits: [{
                _id: Math.random(),
                creditId: '',
                creditType: [{
                    _id: Math.random(),
                    creditsInsideType: ''
                }]
            }],
            year: "",
            category: "",
            awardCategory: "",
            myLibraryScreeningCode: 0,
            myLibraryShift72Id: '',
            myLibraryAudioShift72Id: '',
            isMyLibraryAudio: false,
            myLibraryFirstHalf: '',
            myLibrarySecondHalf: '',
            awardSponsorLogo: "",
            votes: "",
            isExplicitContent: false,
            explicitContent: EditorState.createEmpty(),
            sponsorLogo: "",
            screeningMoreInfoTitle: "",
            screeningMoreInfo: EditorState.createEmpty(),
            country: "",
            language: '',
            runTime: '',
            website: "",
            contact: [
                {
                    _id: Math.random(),
                    emailPhone: '',
                }
            ],

            genre: [],
            interestTrack: [],
            accessibility: [],
            dateTime: [
                {
                    _id: Math.random(),
                    screeningType: { _id: '1', name: 'Premiere' },
                    screeningEventiveId: '',
                    locations: [],
                    locationType: { _id: '1', name: 'In-Person' },
                    date: new Date(),
                    endDate: new Date(),
                    accessibility:[],
                    interestTrack:[],
                    maxWaitListSlots:0,
                    waitListSlotValid:'',
                    hideFromLive:false,
                    supressVoting:false,
                    start: {
                        date: new Date(),
                        hours: { value: '7', label: '7' },
                        minutes: { value: '30', label: '30' },
                        state: { value: 'AM', label: 'AM' }
                    },
                    end: {
                        date: new Date(),
                        hours: { value: '8', label: '8' },
                        minutes: { value: '30', label: '30' },
                        state: { value: 'AM', label: 'AM' }
                    },
                    premierScreening: {
                        waitingRoomTrailerShift72Id: "",
                        isSponsor: false,
                        sponsorLogo: ""
                    },
                    Shift72Id: '',
                    audioDescriptionShift72Id: "",
                    piEarlyAccessShift72Id: '',
                    piEarlyAccessAudioShift72Id: '',
                    isPIEarlyAccessAudio: false,
                    emptyLocationError: '',
                    screeningCode: 0,
                    passBuckets : [],
                }
            ],
            qaReplayLink: "",
            teamConnection: [{
                name: "",
                email: ""
            }],
            artist: [{
                _id: Math.random(),
                image: "",
                name: "",
                description: EditorState.createEmpty(),
                youtube: "",
                instagram: "",
                twitter: "",
            }],
            maxNumberOfRules: 4,
            creditLabel: [],
            images: [
                {
                    _id: Math.random(),
                    link: "",
                    inSite: ""
                },
                {
                    _id: Math.random(),
                    link: "",
                    inSite: ""
                },
                {
                    _id: Math.random(),
                    link: "",
                    inSite: ""
                }
            ],
            waitListSlotValid:'',
            creditCount:1,
            publicContact: {
                firstName: '',
                middleName: '',
                lastName: '',
                company: '',
                publicEmail: '',
                website: '',
                phoneNumber: '',
                type: '',
            },
            postFestivalContact: {
                firstName: '',
                middleName: '',
                lastName: '',
                company: '',
                publicEmail: '',
                website: '',
                phoneNumber: '',
                type: '',
            },
            dropList: [],
            shortProgrammeFilms: [],
            dropListInside: {},
            shortFilms: [],
            shortIntroduction: '',
            shortPopUp: false,
            searchField: '',
            filmEdited: false,
        }
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                urlValidation: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                websiteValid: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                apostrophe: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([a-zA-Z '. -]*)$/i) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                companyName: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([-a-zA-Z0-9 ' , . & !]*)$/i) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                wordLimit: {  // Custom validator for word count
                    message: "The :attribute must be a maximum of :limit words.",
                    rule: (val, params) => {
                        if (!val) return true;
                        let text = "";
                        if (typeof val.getCurrentContent === 'function') {
                            text = val.getCurrentContent().getPlainText();
                        } else if (typeof val === 'string') {
                            text = val.replace(/<[^>]*>?/gm, ''); // Basic tag strip
                        } else {
                            return true;
                        }
                        return text.trim().split(/\s+/).filter(_ => _ !== '').length <= parseInt(params[0])
                    },
                    messageReplace: (message, params) => message.replace(":limit", params[0]), // Dynamically replace :limit in the message
                    required: false,
                },
                shortIntroduction: {
                    message: "The :attribute must be a maximum of 30 words.",
                    rule: (val, params) => {
                        if (!val) return true;
                        let text = "";
                        if (typeof val === 'string') {
                            text = val.replace(/<[^>]*>?/gm, ''); // Basic tag strip
                        } else if (typeof val.getCurrentContent === 'function') {
                            text = val.getCurrentContent().getPlainText();
                        } else {
                            return true;
                        }
                        return text.trim().split(/\s+/).filter(_ => _ !== '').length <= 30;
                    },
                    required: false,
                }
            }
        });
        this.apiserve = new service();
    }

    normalizeDraftHtml = (editorState) => {
        if (!editorState) return '';
        const content = typeof editorState.getCurrentContent === 'function' ? editorState.getCurrentContent() : null;
        if (!content || !content.hasText()) return '';
        const html = draftToHtml(convertToRaw(content)).trim();
        return html === '<p></p>' || html === '<div></div>' ? '' : html;
    }

    getCurrentFormData = () => {
        const {
            title, article, year, runTime, company, website, qaReplayLink, 
            mediaId, fileMakerId, eventiveId, 
            category, access, awardCategory,
            genre, interestTrack, accessibility,
            credits, dateTime, artist, teamConnection, shortFilms, images,
            editorState, editorStateShort, editorStateExplicitContent, editorStateScreeningMoreInfo,
            shortIntroduction, isExplicitContent, screeningMoreInfoTitle,
            publicContact, postFestivalContact, fullNameFirst, fullEmailFirst, fullNameSecond, fullEmailSecond,
            country, language, contact, awardSponsorLogo, sponsorLogo, votes,
            shortFlim, indiesFlim, shortProgramme1,
            isMyLibraryScreen, dropDownRemoveForIndiesSeries
        } = this.state;

        return {
            title: title || '',
            article: article || '',
            year: year || '',
            runTime: runTime || '',
            company: company || '',
            website: website || '',
            qaReplayLink: qaReplayLink || '',
            mediaId: mediaId || '',
            fileMakerId: fileMakerId || '',
            eventiveId: eventiveId || '',
            category: category?.value || '',
            access: access?.value || '',
            awardCategory: awardCategory?.value || '',
            isExplicitContent: !!isExplicitContent,
            screeningMoreInfoTitle: screeningMoreInfoTitle || '',
            shortIntroduction: shortIntroduction || '',
            genre: (genre || []).map(g => g.value).sort(),
            interestTrack: (interestTrack || []).map(i => i.value).sort(),
            accessibility: (accessibility || []).map(a => a.value).sort(),
            credits: (credits || []).map(c => ({
                creditId: c.creditId?.value || '',
                creditType: (c.creditType || []).map(ct => ct.creditsInsideType || '').sort()
            })),
            dateTime: (dateTime || []).map(d => ({
                screeningType: d.screeningType?.value || d.screeningType?._id || '',
                locationType: d.locationType?.value || d.locationType?._id || '',
                locations: (d.locations || []).map(l => l.value || l._id || '').sort(),
                date: d.date ? moment(d.date).format('YYYY-MM-DD') : '',
                endDate: d.endDate ? moment(d.endDate).format('YYYY-MM-DD') : '',
                maxWaitListSlots: parseInt(d.maxWaitListSlots) || 0,
                hideFromLive: !!d.hideFromLive,
                supressVoting: !!d.supressVoting,
                accessibility: (d.accessibility || []).map(a => a.value || a._id || '').sort(),
                interestTrack: (d.interestTrack || []).map(it => it.eventiveId || '').sort(),
                start: {
                    hours: d.start?.hours?.value || '',
                    minutes: d.start?.minutes?.value || '',
                    state: d.start?.state?.value || ''
                },
                end: {
                    hours: d.end?.hours?.value || '',
                    minutes: d.end?.minutes?.value || '',
                    state: d.end?.state?.value || ''
                },
                eventiveId: d.eventiveId || '',
                screeningEventiveId: d.screeningEventiveId || '',
                premierScreening: {
                    isSponsor: !!(d.isSponsor ?? d.premierScreening?.isSponsor),
                    sponsorLogo: d.sponsorLogo ?? d.premierScreening?.sponsorLogo ?? '',
                    waitingRoomTrailerShift72Id: d.premierScreening?.waitingRoomTrailerShift72Id ?? d.waitingRoomTrailerShift72Id ?? ''
                }
            })),
            artist: (artist || []).map(a => ({
                name: a.name || '',
                description: this.normalizeDraftHtml(a.description),
                youtube: (a.youtube || '').replace('https://www.', ''),
                instagram: a.instagram || '',
                twitter: a.twitter || '',
                image: a.image || ''
            })),
            teamConnection: [
                { name: fullNameFirst || '', email: fullEmailFirst || '' },
                { name: fullNameSecond || '', email: fullEmailSecond || '' }
            ],
            shortFilms: (shortFilms || []).map(f => f._id || '').sort(),
            images: (images || []).map(img => ({
                link: img.link || '',
                inSite: img.inSite || ''
            })),
            description: this.normalizeDraftHtml(editorState),
            shortDescription: this.normalizeDraftHtml(editorStateShort),
            explicitContent: this.normalizeDraftHtml(editorStateExplicitContent),
            screeningMoreInfo: this.normalizeDraftHtml(editorStateScreeningMoreInfo),
            publicContact: {
                firstName: publicContact?.firstName || '',
                middleName: publicContact?.middleName || '',
                lastName: publicContact?.lastName || '',
                company: publicContact?.company || '',
                publicEmail: publicContact?.publicEmail || '',
                website: publicContact?.website || '',
                phoneNumber: publicContact?.phoneNumber || '',
                type: publicContact?.type || ''
            },
            postFestivalContact: {
                firstName: postFestivalContact?.firstName || '',
                middleName: postFestivalContact?.middleName || '',
                lastName: postFestivalContact?.lastName || '',
                company: postFestivalContact?.company || '',
                publicEmail: postFestivalContact?.publicEmail || '',
                website: postFestivalContact?.website || '',
                phoneNumber: postFestivalContact?.phoneNumber || '',
                type: postFestivalContact?.type || ''
            },
            country: country || '',
            language: language || '',
            contact: (contact || []).map(c => ({
                emailPhone: c.emailPhone || ''
            })),
            awardSponsorLogo: awardSponsorLogo || '',
            sponsorLogo: sponsorLogo || '',
            votes: votes || '',
            shortFlim: !!shortFlim,
            indiesFlim: !!indiesFlim,
            isMyLibraryScreen: !!isMyLibraryScreen,
            dropDownRemoveForIndiesSeries: !!dropDownRemoveForIndiesSeries,
            shortProgrammeId: shortProgramme1?.value || shortProgramme1?._id || (typeof shortProgramme1 === 'string' ? shortProgramme1 : '')
        };
    }

    markFilmEdited = () => {
        const currentData = this.getCurrentFormData();
        if (!this.state.initialData) {
            this.setState({ initialData: cloneDeep(currentData), isFilmEdited: false });
            return;
        }

        const isEdited = !isEqual(this.state.initialData, currentData);
        if (isEdited !== this.state.isFilmEdited) {
            this.setState({ isFilmEdited: isEdited });
        }
    }

    updateState = (newState, callback) => {
        this.setState(newState, () => {
            this.markFilmEdited();
            if (callback) {
                callback();
            }
        });
    }

    componentWillUnmount = () => {
        const recordId = this.props.filmEditId;

        window.removeEventListener('beforeunload', this._handleBeforeUnload);

        if (recordId && !this._hasLeftPresence) {
            this.apiserve.sendevent("RecordPresence|leave", {
                modelName: "film",
                recordId: recordId
            });
        }

        // this.props.filmEditData('')
        sub.unsubscribe();
        cookies.remove('previewRecordFilm', { path: '/film-preview' });
        this.props.ClearRecordPresence();
    }

    _handleBeforeUnload = () => {
        if (this._hasLeftPresence) return;
        this._hasLeftPresence = true;

        const recordId = this.props.filmEditId;
        if (recordId) {
            this.apiserve.sendevent("RecordPresence|leave", {
                modelName: "film",
                recordId: recordId
            });
        }
    }

    componentDidMount = () => {
        this.props.ClearRecordPresence();
        // RecordPresence join (only in edit mode when filmId exists)
        const recordId = this.props.filmEditId;
        if (recordId) {
            this.apiserve.sendevent("RecordPresence|join", {
                modelName: "film",
                recordId: recordId
            });
            window.addEventListener('beforeunload', this._handleBeforeUnload);
        }

        setTimeout(() => {
            if (!this.state.filmId) {
                this.state.dateTime.map(date => {
                    date.screeningEventiveId = this.props.film.screnningTypeList[0].eventiveTagId
                })
                this.setState({}, () => {
                    const currentData = this.getCurrentFormData();
                    this.setState({ initialData: cloneDeep(currentData), isFilmEdited: false });
                })
            }
        }, 1000)
        if (this.state.filmId) {
            this.apiserve.sendevent("film|getAllDetail", {
                filmId: this.state.filmId
            });
            this.apiserve.sendevent("fpg|shortProgramme|dropList|get", {});
        }

        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "film|create":
                    if (!response.error) {
                        this.setState({
                            loaderFlag: false,
                            filmDisabled: true,
                        })
                        if(response.data.eventiveError && response.data.eventiveError.length > 0){
                            this.setState({
                                errorScreeningPopup: true,
                                errorData : response.data.eventiveError
                            })
                        } else {
                            this.props.history.push('/filmlist')
                            this.apiserve.success('Created successfully.')
                            this.setState({ isFilmEdited: false })
                        }
                    }
                    else {
                        this.setState({
                            filmDisabled: false,
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data,
                            loaderFlag: false,
                        })
                    }

                    break;
                case "film|edit":
                    if (!response.error) {
                        this.setState({
                            loaderFlag: false,
                            filmDisabled: true,
                        })
                        if(response.data.eventiveError && response.data.eventiveError.length > 0){
                            this.setState({
                                errorScreeningPopup: true,
                                errorData : response.data.eventiveError
                            })
                        } else {
                            this.apiserve.success('Updated successfully.')
                            this.apiserve.sendevent("film|getAllDetail", {
                                filmId: response.data._id
                            });
                            this.setState({
                                loaderFlag: false,
                                filmDisabled: false,
                                isFilmEdited: false,
                            })
                        }
                    }
                    else if (response.data?.error === 'CONFLICT_DETECTED') {
                        this.props.SetRecordConflict({
                            userName: 'another user',
                            updatedAt: response.data?.data?.currentUpdatedAt
                        });
                        this.setState({ showConflictModal: true, loaderFlag: false, filmDisabled: false });
                    } else {
                        this.setState({
                            loaderFlag: false,
                            filmDisabled: false,
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })
                    }

                    break;
                case "film|previewfilm":
                    if (!response.error) {
                        this.setState({loaderFlag: false,filmDisabled: false})
                        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_FPG + 'film-preview?id=' + response.data._id);
                    }
                    else {
                        this.setState({loaderFlag: false,filmDisabled: false})
                    }

                    break;
                case "film|getAllDetail":
                    if (!response.error) {
                        const allInitial = this.props.allInitial;
                        const filmInitial = (allInitial && allInitial.film) || {};
                        if(response.data.credits.length > 0){
                            var creditData = response.data && response.data.credits.map(item => {
    
                                var credits = {
                                    _id: item._id,
                                    creditId: { value: item.creditId._id, label: item.creditId.name }, creditType: [],
                                    identifier: item.identifier,
                                    creditTypeValue: item.creditTypeValue
                                }
                                item && item.creditType.map(creditList => {
                                    var creditType = {
                                        _id: creditList._id,
                                        creditsInsideType: creditList.creditsInsideType,
                                        creditTypeId:creditList.creditTypeId
                                    }
                                    credits && credits.creditType.push(creditType)
                                })
                                return credits
                            })
                        } else {
                            var creditData = [{
                                _id: Math.random(),
                                creditId: '',
                                creditType: [{
                                    _id: Math.random(),
                                    creditsInsideType: '',
                                    creditTypeId:Math.random().toString()
                                }]
                            }]
                        }

                        var genreData = response.data && response.data.genre.map(item => {
                            var genre = getData(item, filmInitial.genre || [])
                            return genre
                        })

                        var interestTrackData = response.data && response.data.interestTrack.map(item => {
                            var interestTrack =getData(item, filmInitial.interestTrack || [])
                            return interestTrack
                        })

                        var accessibilityData = response.data && response.data.accessibility.map(item => {
                            var accessibility = getData(item, filmInitial.accessibility || [])
                            return accessibility
                        })
                        

                        var dateTimeDate = (response.data?.dateTime || []).map(item => {
                            let hoursStart = moment(item.date).tz("US/Mountain").format('h');
                            let minutesStart = moment(item.date).tz("US/Mountain").format('mm')
                            let statestart = moment(item.date).tz("US/Mountain").format('A')

                            let yearstart = moment(item.date).tz("US/Mountain").format('YYYY')
                            let monthstart = moment(item.date).tz("US/Mountain").format('MM') - 1
                            let datestart = moment(item.date).tz("US/Mountain").format('DD')
                            if (item.screeningType === "1" || item.screeningType === "2" || item.screeningType === "3") {
                                this.setState({
                                    dropDownRemoveForIndiesSeries: false,
                                })
                            } else {
                                this.setState({
                                    dropDownRemoveForIndiesSeries: true,
                                })
                            }
                            let yearend = moment(item.endDate).tz("US/Mountain").format('YYYY')
                            let monthend = moment(item.endDate).tz("US/Mountain").format('MM') - 1
                            let dateend = moment(item.endDate).tz("US/Mountain").format('DD')
                            let hoursend = moment(item.endDate).tz("US/Mountain").format('h');
                            let minutesend = moment(item.endDate).tz("US/Mountain").format('mm')
                            let stateend = moment(item.endDate).tz("US/Mountain").format('A')

                            item.interestTrack = (item.interestTrack || []).map(id => {
                                const data = (filmInitial.interestTrack || []).find(_ => _._id === id);
                                return data ? { value: data._id, label: data.name, eventiveId: data.eventiveId } : null
                            }).filter(Boolean)

                            item.accessibility = item.accessibility.map(acc => {
                                const data = (filmInitial.accessibility || []).find(_ => _.eventiveId === acc);
                                return { value: data._id, label: data.name, eventiveId: data.eventiveId }
                            })
                            item.interestTrack = (item.interestTrack || []).map(id => {
                                const track = filmInitial && filmInitial.interestTrack && filmInitial.interestTrack.find(t => t.eventiveId === id)
                                return track ? { value: track._id, label: track.name, eventiveId: track.eventiveId } : null
                            }).filter(Boolean)
                            var dateTime = {
                                _id: item._id,
                                screeningType: item.screeningType === undefined ? { _id: '1', label: 'Premiere' } : { _id: item.screeningType, label: item.name },
                                eventiveId: item.eventiveId,
                                screeningEventiveId: item.screeningEventiveId,
                                locationEventiveId: item.locationEventiveId,
                                accessibility:item?.accessibility ? item?.accessibility : [],
                                interestTrack:item?.interestTrack ? item?.interestTrack : [],
                                openCaption:item?.accessibility ? item?.accessibility.length > 0 ? true : false : false,
                                locationType: item.locationType === undefined ? { _id: "2", label: "Online" } : { _id: item.locationType, label: item.name },
                                locations: this.getLocations(item.locations),
                                maxWaitListSlots:item.maxWaitListSlots ? item.maxWaitListSlots : 0,
                                locationCity: item.locationCity || null,
                                waitListSlotValid:'',
                                hideFromLive:item.hideFromLive ? item.hideFromLive : false,
                                supressVoting:item.supressVoting ? item.supressVoting : false,
                                date: new Date(yearstart, monthstart, datestart),
                                endDate: new Date(yearend, monthend, dateend),
                                start: {
                                    date: new Date(yearstart, monthstart, datestart),
                                    hours: { value: hoursStart, label: hoursStart },
                                    minutes: { value: minutesStart, label: minutesStart },
                                    state: { value: statestart, label: statestart }
                                },
                                end: {
                                    date: new Date(yearend, monthend, dateend),
                                    hours: { value: hoursend, label: hoursend },
                                    minutes: { value: minutesend, label: minutesend },
                                    state: { value: stateend, label: stateend }
                                },
                                screeningCode: item.screeningCode
                            }
                            if (item.screeningType === "1") {
                                this.setState({
                                    screeninfpopupPre: true,
                                    datePremiere: item.date
                                })
                            } else {
                                this.setState({
                                    screeninfpopupPre: false,
                                })
                            }
                            return dateTime

                        })

                        var Locationisset = response.data && response.data.dateTime.map(item => {

                            let hoursStart = moment(item.date).tz("US/Mountain").format('h');
                            let minutesStart = moment(item.date).tz("US/Mountain").format('mm')
                            let statestart = moment(item.date).tz("US/Mountain").format('A')
                            if (item.screeningType === "1" || item.screeningType === "2" || item.screeningType === "3") {
                                this.setState({
                                    dropDownRemoveForIndiesSeries: false,
                                })
                            } else {
                                this.setState({
                                    dropDownRemoveForIndiesSeries: true,
                                })
                            }
                            let yearstart = moment(item.date).tz("US/Mountain").format('YYYY')
                            let monthstart = moment(item.date).tz("US/Mountain").format('MM') - 1
                            let datestart = moment(item.date).tz("US/Mountain").format('DD')

                            const yearend = moment(item.endDate).tz("US/Mountain").format('YYYY')
                            const monthend = moment(item.endDate).tz("US/Mountain").format('MM') - 1
                            const dateend = moment(item.endDate).tz("US/Mountain").format('DD')
                            let hoursend = moment(item.endDate).tz("US/Mountain").format('h');
                            let minutesend = moment(item.endDate).tz("US/Mountain").format('mm')
                            let stateend = moment(item.endDate).tz("US/Mountain").format('A')
                            const dateTime = {
                                _id: item._id,
                                screeningType: item.screeningType === undefined ? { _id: '1', label: 'Premiere' } : { _id: item.screeningType, label: item.name },
                                eventiveId: item.eventiveId,
                                locationType: item.locationType === undefined ? { _id: "2", label: "Online" } : { _id: item.locationType, label: item.name },
                                locations: item.locations,
                                maxWaitListSlots:item.maxWaitListSlots ? item.maxWaitListSlots : 0,
                                waitListSlotValid:'',
                                hideFromLive:item.hideFromLive ? item.hideFromLive : false,
                                supressVoting:item.supressVoting ? item.supressVoting : false,
                                date: new Date(yearstart, monthstart, datestart),
                                endDate: new Date(yearend, monthend, dateend),
                                accessibility:item?.accessibility ? item?.accessibility : [],
                                openCaption:item?.accessibility ? item.accessibility.length > 0 ? true : false : false,
                                start: {
                                    date: new Date(yearstart, monthstart, datestart),
                                    hours: { value: hoursStart, label: hoursStart },
                                    minutes: { value: minutesStart, label: minutesStart },
                                    state: { value: statestart, label: statestart }
                                },
                                end: {
                                    date: new Date(yearend, monthend, dateend),
                                    hours: { value: hoursend, label: hoursend },
                                    minutes: { value: minutesend, label: minutesend },
                                    state: { value: stateend, label: stateend }
                                },
                                screeningCode: item.screeningCode
                            }
                            return dateTime


                        })
                        this.setState({
                            Locationisset: Locationisset
                        })

                        var images = response.data && response.data.images.map((image) => {
                            var imageData = {
                                _id: Math.random(),
                                inSite: image.inSite,
                                link: image.link
                            }
                            return imageData
                        })

                        if (response.data.description) {
                            const blocksFromHtml = htmlToDraft(response.data.description);
                            const { contentBlocks, entityMap } = blocksFromHtml;
                            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                            const editorState = EditorState.createWithContent(contentState);
                            this.setState({
                                editorState: editorState,
                            })
                        }
                        if (response.data.shortDescription) {
                            const blocksFromHtml = htmlToDraft(response.data.shortDescription);
                            const { contentBlocks, entityMap } = blocksFromHtml;
                            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                            const editorStateShort = EditorState.createWithContent(contentState);
                            this.setState({
                                editorStateShort: editorStateShort,
                            })
                        }
                        let editorStateExplicitContent;
                        if (response.data.explicitContent) {
                            let blocksFromHtml = htmlToDraft(response.data.explicitContent);
                            let { contentBlocks, entityMap } = blocksFromHtml;
                            let contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                            editorStateExplicitContent = EditorState.createWithContent(contentState);
                        }
                        let editorStateScreeningMoreInfo;

                        if (response.data.screeningMoreInfo) {
                            let blocksFromHtml = htmlToDraft(response.data.screeningMoreInfo);
                            let { contentBlocks, entityMap } = blocksFromHtml;
                            let contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
                            editorStateScreeningMoreInfo = EditorState.createWithContent(contentState);
                        }


                        var artist =
                            response.data &&
                            response.data.artist.map((item) => {
                                var artistData = {
                                    _id: Math.random(),
                                    image: item.image,
                                    name: item.name,
                                    description: item.description,
                                    youtube: (item.youtube || '').replace('https://www.', ''),
                                    instagram: (item.instagram || '').replace('https://www.instagram.com/', ''),
                                    twitter: (item.twitter || '').replace('https://x.com/', ''),
                                };
                                return artistData;
                            });

                        if (artist !== undefined) {

                            try {
                                const docs = artist.map((item) => {
                                    const blocksFromHtml = htmlToDraft(item.description);
                                    const { contentBlocks, entityMap } = blocksFromHtml;
                                    const contentState = ContentState.createFromBlockArray(
                                        contentBlocks,
                                        entityMap
                                    );
                                    item.description = EditorState.createWithContent(contentState);
                                    return item;
                                });
                            } catch (error) {
                            }

                        }
                        this.setState(
                            {
                                artist:
                                    artist?.length === 0 || artist === undefined || artist === null
                                        ? this.state.artist
                                        : artist,
                            });
                        this.setState({
                            previewRecordFilm: response.data,
                            mediaId: response.data.mediaId,
                            fileMakerId: response.data.fileMakerId,
                            eventiveId: response.data.eventiveId,
                            access: getData(response.data.access, filmInitial.access || []),
                            title: response.data.title,
                            company: response.data.company,
                            images: images,
                            article: response.data.article,
                            credits: creditData,
                            year: response.data.year,
                            category: getData(response.data.category, filmInitial.category || []),
                            awardCategory: getData(response.data.awardCategory, filmInitial.awardCategory || []),
                            awardSponsorLogo: response.data.awardSponsorLogo,
                            isExplicitContent: response.data.isExplicitContent,
                            editorStateExplicitContent: editorStateExplicitContent,
                            explicitContent: response.data.explicitContent,
                            sponsorLogo: response.data.sponsorLogo,
                            screeningMoreInfoTitle: response.data.screeningMoreInfoTitle,
                            editorStateScreeningMoreInfo: editorStateScreeningMoreInfo,
                            country: response.data.country,
                            language: response.data.language,
                            runTime: response.data.runTime,
                            website: (response.data.website || '').replace('https://www.', ''),
                            contact: response.data.contact,
                            genre: genreData,
                            interestTrack: interestTrackData,
                            accessibility: accessibilityData,
                            dateTime: dateTimeDate,
                            qaReplayLink: response.data.qaReplayLink,
                            publicContact: response.data.publicContact ? {...response.data.publicContact, website: (response.data.publicContact.website || '').replace('https://www.', '')} : this.state.publicContact,
                            postFestivalContact: response.data.postFestivalContact ? {...response.data.postFestivalContact, website: (response.data.postFestivalContact.website || '').replace('https://www.', '')} : this.state.postFestivalContact,
                            fullNameFirst: response.data.teamConnection[0] && response.data.teamConnection[0].name,
                            fullEmailFirst: response.data.teamConnection[0] && response.data.teamConnection[0].email,
                            fullNameSecond: response.data.teamConnection[1] && response.data.teamConnection[1].name,
                            fullEmailSecond: response.data.teamConnection[1] && response.data.teamConnection[1].email,
                            artist: artist?.length === 0 || artist === undefined || artist === null
                                ? this.state.artist
                                : artist,
                            shortProgramme1: { value: response.data.shortProgramme && response.data.shortProgramme._id, name: response.data.shortProgramme && response.data.shortProgramme.name, date: response.data.shortProgramme && response.data.shortProgramme.date },
                            shortProgramme45: response.data?.shortProgramme,
                            shortIntroduction: response?.data?.shortIntroduction ?? "",
                            shortFilms: response?.data?.shortFilms ?? [],
                        }, () => {
                            const resolvedCategory = resolveFromInitial(allInitial, 'film', 'category', response?.data?.category ? (response?.data?.category?._id || response?.data?.category) : null);
                            if (resolvedCategory.type === 2) {
                                this.setState({
                                    shortFlim: true,
                                })
                            }
                            if (resolvedCategory && resolvedCategory.type === 3) {
                                this.setState({
                                    indiesFlim: true,
                                })
                            }
                            // Capture initial data for edited tracking
                            const currentData = this.getCurrentFormData();
                            this.setState({ initialData: cloneDeep(currentData), isFilmEdited: false });
                        })
                        this.props.setLastUpdated( {
                            updatedAt: response?.data?.updatedAt,
                            updatedBy: {
                                fname: response?.data?.updatedBy?.fname,
                                lname: response?.data?.updatedBy?.lname
                            }
                        })
                        this.setState({ editStartVersion: response?.data?.updatedAt || null });
                    } else {
                        this.setState({
                            errorPopup: true,
                            errorMsg: response.data.error ? response.data.error : response.data
                        })
                    }
                    break;
                case "fpg|shortProgramme|dropList|get":
                    if (!response.error) {
                        var dataShort = response && response.data.map(item => {
                            var shortProgramme = {
                                _id: item._id, name: item.name, date: item.date
                            }
                            return shortProgramme
                        })
                        this.setState({
                            shortProgramme: dataShort
                        })
                    }

                    break;

                case "film|dropList|short":
                    if (!response.error) {
                        if (Array.isArray(response.data) && response.data.length > 0) {
                            const dropList = response.data
                                .map(item => ({ ...item, value: false }))
                                .filter(item =>
                                    !this.state.shortProgrammeFilms.some(film => film.film && film.film._id === item._id)
                                );
                            this.setState({ dropList });
                        }
                    }
                    break;
                case "RecordPresence|viewersUpdate":
                    if (response?.data?.recordId === this.props.filmEditId) {
                        const currentUserId = this.props.getLoginAdminByID;
                        const viewers = response?.data?.viewers || [];
                        const currentUserSessionCount = viewers.filter(v => v?.userId === currentUserId).length;
                        const currentUserHasMultipleSessions = currentUserSessionCount > 1;
                        const seenIds = new Set();
                        const filteredViewers = viewers
                            .filter(v => {
                                if (v?.userId === currentUserId) {
                                    return currentUserHasMultipleSessions;
                                }
                                return true;
                            })
                            .filter(v => {
                                if (seenIds.has(v?.userId)) return false;
                                seenIds.add(v?.userId);
                                return true;
                            })
                            .map(v => ({
                                userId: v?.userId,
                                userName: `${v?.fname || ''} ${v?.lname || ''}`.trim() || 'Unknown User'
                            }));
                        this.props.SetRecordViewers(filteredViewers);
                    }
                    break;
                case "RecordPresence|recordUpdated":
                    if (response?.data?.recordId === this.props.filmEditId && response?.data?.updatedBy?._id !== this.props.getLoginAdminByID) {
                        const updatedBy = response?.data?.updatedBy;
                        this.props.SetRecordConflict({
                            userName: updatedBy ? `${updatedBy?.fname || ''} ${updatedBy?.lname || ''}`.trim() : 'another user',
                            updatedAt: response?.data?.updatedAt
                        });
                    }
                    break;

                case "RecordPresence|join":
                    if (!response.error && response?.data?.recordUpdatedAt) {
                        this.setState({ editStartVersion: response.data.recordUpdatedAt });
                    }
                    break;

                default:
                    break;
            }
        });
    }

    getLocations = (locations) => {
        return locations && locations.length > 0 && locations.map(item => {
            let data = this.props.film.locations && this.props.film.locations.find(i => i._id === item)
            var location = {
                value: data._id, label: data.name, isSet: data.isSet, city: data.city, state: data.state, maxWaitListSlots:data?.maxWaitListSlots
            }
            return location
        })
    }

    onEditorStateChange = (editorState) => {
        this.updateState({
            editorState,
        });
    };

    onEditorStateChangeShort = (editorStateShort) => {
        this.updateState({
            editorStateShort,
        }, () => {
            this.validator.showMessageFor('shortDescription')
        });
    };

    onEditorStateChangeExplicitContent = (editorStateExplicitContent) => {
        this.updateState({
            editorStateExplicitContent,
        });
    };

    onEditorStateChangeScreeningMoreInfo = (editorStateScreeningMoreInfo) => {
        this.updateState({
            editorStateScreeningMoreInfo,
        });
    };

    handleChangeGenre = selectedOptionGenre => {
        this.updateState({
            genre: selectedOptionGenre
        });
    };

    handleChangenInterestTrack = interestTrack => {
        this.updateState({
            interestTrack: interestTrack
        })
    };

    handleChangenAccessibility = accessibility => {
        this.updateState({
            accessibility: accessibility
        })
    };
    handleChangenAccessibilityScreening = (accessibility, id) => {
        const dateTime = this.state.dateTime.map((item) => {
            if (item._id === id) {
                return { ...item, accessibility };
            }
            return item;
        });
        this.setState({
            dateTime
        }, () => {
            this.markFilmEdited();
        });
    };

    handleChangenInterestTrackScreening = (interestTrack, id) => {
        const dateTime = this.state.dateTime.map((item) => {
            if (item._id === id) {
                return { ...item, interestTrack };
            }
            return item;
        });
        this.setState({
            dateTime
        }, () => {
            this.markFilmEdited();
        });
    };


    onInputChange = (e) => {
        const { name, value } = e.target;
        this.updateState({
            [name]: name === 'website' ? value.replace('https://www.', '') : value
        });
    }

    dropChange = (e) => {
        const { name, value } = e.target;
        this.updateState({
            [name]: { value: value, label: name }
        }, () => {
            var newDateAndTime = [{
                _id: Math.random(),
                screeningType: { _id: '1', name: 'Premiere' },
                screeningEventiveId: this.props.film && this.props.film.screnningTypeList[0].eventiveTagId,
                locationType: { _id: '1', label: 'In-Person' },
                locations: [],
                maxWaitListSlots:0,
                waitListSlotValid:'',
                hideFromLive: false,
                supressVoting: false,
                date: new Date(),
                endDate: new Date(),
                accessibility:[],
                interestTrack:[],
                start: {
                    date: new Date(),
                    hours: { value: '7', label: '7' },
                    minutes: { value: '30', label: '30' },
                    state: { value: 'AM', label: 'AM' }
                },
                end: {
                    date: new Date(),
                    hours: { value: '8', label: '8' },
                    minutes: { value: '30', label: '30' },
                    state: { value: 'AM', label: 'AM' }
                },
                emptyLocationError: ''
            }]

            this.props.film.category.forEach((item) => {
                if (item._id === value) {
                    if (item.type === 2) {
                        this.setState({
                            shortFlim: true,
                            indiesFlim: false,
                            dropDownRemoveForIndiesSeries: false,
                            dropListInside: {},
                            shortFilms: [],
                            shortIntroduction: '',
                            interestTrack: [...((this.state.interestTrack && this.state.interestTrack.length > 0) ? this.state.interestTrack.filter(_ => _.label.toLowerCase() !== "all shorts".toLowerCase()) : []),((item = this.props.film?.interestTrack?.find(i => i.name?.toLowerCase() === "all shorts".toLowerCase())) => 
                                item ? { value: item._id, label: item.name } : null)()]
                        }, () => {
                            this.apiserve.sendevent("fpg|shortProgramme|dropList|get", {});
                        })
                    }
                    if (item.type === 3) {
                        this.setState({
                            indiesFlim: false,
                            dropDownRemoveForIndiesSeries: false,
                            interestTrack:(this.state.interestTrack && this.state.interestTrack.length > 0) ? this.state.interestTrack.filter(i => i.label?.toLowerCase() !== "all shorts".toLowerCase()) : []
                        })
                        this.setState({})
                    }
                    if (item.type === 1) {
                        this.state.dateTime.map((date)=> {
                            if(date.locationType._id === '2'){
                                date.screeningType = {_id: this.props.film.screnningTypeList[0].type, label: this.props.film.screnningTypeList[0].name}
                                date.screeningEventiveId = this.props.film.screnningTypeList[0].eventiveTagId
                            }
                        })
                        this.setState({
                            indiesFlim: false,
                            shortFlim: false,
                            dropDownRemoveForIndiesSeries: false,
                            interestTrack:(this.state.interestTrack && this.state.interestTrack.length > 0) ? this.state.interestTrack.filter(i => i.label?.toLowerCase() !== "all shorts".toLowerCase()) : []
                        })
                    }
                }
            })

        })
    }

    dropChangeShortProgram = (e) => {
        const { name, value } = e.target;

        this.updateState({
            [name]: { _id: value, label: name },
        }, () => {
            var dataShort = [];
            this.state.shortProgramme.map(item => {
                if (item._id === value) {
                    var shortProgramme = {
                        _id: item._id, name: item.name, date: item.date
                    }
                    dataShort.push(shortProgramme)
                }
            })

            this.setState({
                shortFlim: true,
                shortDateTime: dataShort
            })
        });
    }

    dropChangeCountryYear = (e) => {
        const { name, value } = e.target;
        this.updateState({
            [name]: value
        })
    }



    ClosemessageModal = () => {
        this.setState({
            messageModal: false,
        })
    }

    cancelFilmLit = () => {
        this.setState({
            discardPopup: true
        })
    }

    getMtTime = (date) => {
        //Get offset from mountain time using UTC
        //change 360 t0 420
        let ABBR = moment.tz("America/Denver").format("z");
        let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);
        // add that offset in date
        return moment(date).add(offDifference, 'minutes').toISOString()
    }

    checkCustomValidation = () => {
        const { dateTime } = this.state;

        let errorFlag = true;
        dateTime.length > 0 && dateTime.map(date => {
            const type = date.locationType._id || date.locationType.value;
            if (this.state.category.value != "5fa7d17c0329c105a039f9f7") {
                if (type === "1" || type === "3") {
                    try {
                        if (date.locations === null || date.locations === false || date.locations.length === 0 || date.locations.length === undefined) {
                            date.emptyLocationError = 'Location is required for all screening times.'
                            errorFlag = false;
                        }
                        else {
                            date.emptyLocationError = ''
                        }
                    } catch (error) {
                        date.emptyLocationError = ''
                    }
                }
                else {
                    date.emptyLocationError = ''
                }
            }
        })

        this.setState({})
        if(this.state.shortFlim === true ) return true 
        else return errorFlag;
    }

    checkMyLibraryScreening = () => {
        const { dateTime } = this.state;
        let mylibraryError = false
        let myLibraryScreening = ['6','7','8']
        dateTime.length > 0 && dateTime.map((date) => {
            if (this.state.category.value != "5fa7d17c0329c105a039f9f7" && this.state.category.value != "5fb39fe53b70f37b9e8c1335") {
                if(myLibraryScreening.includes(date.screeningType._id)){
                    mylibraryError = true
                }
                else{
                    this.setState({
                        errormyLibrary:true,
                    })
                }
            }else {
                mylibraryError = true
            }
        })
        return mylibraryError
    }

    checkMyLibraryScreening = () => {
        const { dateTime } = this.state;
        let mylibraryError = false
        let myLibraryScreening = ['6','7','8']
        dateTime.length > 0 && dateTime.map((date) => {
            if (this.state.category.value != "5fa7d17c0329c105a039f9f7" && this.state.category.value != "5fb39fe53b70f37b9e8c1335") {
                if(myLibraryScreening.includes(date.screeningType._id)){
                    mylibraryError = true
                }
                else{
                    this.setState({
                        errormyLibrary:true,
                    })
                }
            }else {
                mylibraryError = true
            }
        })
        return mylibraryError
    }

    publicContactChange = (e) => {
        const { name, value } = e.target
        this.setState({
            ...this.state,
            publicContact: {
                ...this.state.publicContact,
                [name]: name === 'website' ? value.replace('https://www.', '') : value
            }
        }, () => {
            this.markFilmEdited();
        })
    }

    postFestivalContactChange = (e) => {
        const { name, value } = e.target
        this.setState({
            ...this.state,
            postFestivalContact: {
                ...this.state.postFestivalContact,
                [name]: name === 'website' ? value.replace('https://www.', '') : value
            }
        }, () => {
            this.markFilmEdited();
        })

    }

    submitFilm = (e, isPreview) => {
        e.preventDefault();

        // Conflict modal check BEFORE socket emit
        if (!isPreview && this.props.recordConflict) {
            this.setState({ showConflictModal: true });
            return;
        }

        let waitlistvalid = false
        this.state.dateTime.map((date) => {
            if(date.waitListSlotValid !== ''){
                waitlistvalid = true
            }
        })
        if (this.validator.allValid() && this.checkCustomValidation() && !waitlistvalid) {
            try {
                this.setState({ loaderFlag: true, filmDisabled: true })
                let creditsData = this.state.credits.map(cl => {
                    let credits = {
                        creditId: cl && cl.creditId && cl.creditId.value,
                        identifier: cl && cl.identifier,
                        creditTypeValue: cl && cl.creditTypeValue,
                        identifierName: this.getActiveCreditLabels().find((e) => e._id === cl.creditId.value)?.name || '',
                        creditType: [],
                    }
                    cl && cl.creditType.map(cli => {
                        console.log(cli,"cli");
                          
                            var creditType = { 
                                creditsInsideType: cli.creditsInsideType,
                                creditTypeId: cli.creditTypeId,
                            }
                            if(cli._id && typeof(cli._id) === 'string') creditType._id = cli._id
                        credits && credits.creditType.push(creditType)
                    })
                    return credits
                });
                var genreData = this.state.genre && this.state.genre.map(e => e.value)

                var interestTrack = this.state.interestTrack && this.state.interestTrack.map(e => e.value)

                var accessibilityData = this.state && this.state.accessibility.map(e => e.value)
                var dateTimeDate = this.state.dateTime && this.state.dateTime.map(item => {
                    let dateTime = {}
                    
                    let id = item._id !== undefined ? item._id.toString() : Math.random().toString()
                    if ((this.state.category.value === "5fa7d17c0329c105a039f9f7" || this.state.category._id === "5fa7d17c0329c105a039f9f7") && (item && item.locationType && item.locationType._id === "1" || item && item.locationType && (item.locationType === "1" && item.locationType.value === "1"))) {

                        item.date.setHours(item.start.state.value === 'PM' || item.start.state.value === 'pm' ? parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) : parseInt(item.start.hours.value) + 12 : parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) - 12 : parseInt(item.start.hours.value), item.start.minutes.value);
                        item.endDate.setHours(item.end.state.value === 'PM' || item.end.state.value === 'pm' ? parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) : parseInt(item.end.hours.value) + 12 : parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) - 12 : parseInt(item.end.hours.value), item.end.minutes.value);
                        dateTime = {
                            _id: id,
                            eventiveId:item && item.eventiveId ? item.eventiveId : '',
                            maxWaitListSlots:item && item.maxWaitListSlots ? item.maxWaitListSlots : 0,
                            accessibility:item?.accessibility?.map(acc => acc.eventiveId),
                            interestTrack:item?.interestTrack?.map(it => it.eventiveId),
                            locationType: item && item.locationType && item.locationType._id || item && item.locationType && item.locationType.value,
                            locationEventiveId: item && item.locationEventiveId,
                            locations: item && item.locations && item.locations.length > 0 ? item.locations.map(e => e.value) : [],
                            premierScreening: item && item.premiereScreeningData && item?.premiereScreeningData,
                            screeningCode: item.screeningCode,
                            passBuckets: item?.passBuckets,
                            hideFromLive:item.hideFromLive ? item.hideFromLive : false,
                            supressVoting:item.supressVoting ? item.supressVoting : false
                        }
                        if(item.locationType._id === '1' || item.locationType.value === '1'){
                            dateTime.locationCity = item && item.locationCity ? item.locationCity : item.locations && item.locations.length > 0 && item.locations[0].city
                        }
                        return dateTime

                    }
                    else if ((this.state.category.value === "5fa7d17c0329c105a039f9f7" || this.state.category._id === "5fa7d17c0329c105a039f9f7") && ((item && item.locationType && item.locationType._id === "2") || (item && item.locationType && (item.locationType === "2" || item.locationType.value === "2")))) {
                        item.date.setHours(item.start.state.value === 'PM' || item.start.state.value === 'pm' ? parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) : parseInt(item.start.hours.value) + 12 : parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) - 12 : parseInt(item.start.hours.value), item.start.minutes.value);
                        item.endDate.setHours(item.end.state.value === 'PM' || item.end.state.value === 'pm' ? parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) : parseInt(item.end.hours.value) + 12 : parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) - 12 : parseInt(item.end.hours.value), item.end.minutes.value);
                        dateTime = {
                            _id: id,
                            eventiveId:item && item.eventiveId ? item.eventiveId : '',
                            maxWaitListSlots:item && item.maxWaitListSlots ? item.maxWaitListSlots : 0,
                            locationEventiveId: item && item.locationEventiveId,
                            locationType: item && item.locationType && item.locationType._id || item && item.locationType && item.locationType.value,
                            locations: item && item.locations && item.locations.length > 0 ? item.locations.map(e => e.value) : [],
                            accessibility:item?.accessibility?.map(acc => acc.eventiveId),
                            interestTrack:item?.interestTrack?.map(it => it.eventiveId),
                            date: this.getMtTime(item.date),
                            endDate: this.getMtTime(item.endDate),
                            hideFromLive:item.hideFromLive ? item.hideFromLive : false,
                            supressVoting:item.supressVoting ? item.supressVoting : false,
                        }
                        if(item.locationType._id === '1' || item.locationType.value === '1'){
                            dateTime.locationCity = item && item.locationCity ? item.locationCity : item.locations && item.locations.length > 0 && item.locations[0].city
                        }
                        return dateTime
                    }
                    else {
                        item.date.setHours(item.start.state.value === 'PM' || item.start.state.value === 'pm' ? parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) : parseInt(item.start.hours.value) + 12 : parseInt(item.start.hours.value) === 12 ? parseInt(item.start.hours.value) - 12 : parseInt(item.start.hours.value), item.start.minutes.value);
                        item.endDate.setHours(item.end.state.value === 'PM' || item.end.state.value === 'pm' ? parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) : parseInt(item.end.hours.value) + 12 : parseInt(item.end.hours.value) === 12 ? parseInt(item.end.hours.value) - 12 : parseInt(item.end.hours.value), item.end.minutes.value);
                        dateTime = {
                            _id: id,
                            screeningType: item.screeningType === undefined ? { _id: this.props.film && this.props.film.screnningTypeList[0].type, label: this.props.film && this.props.film.screnningTypeList[0].name } : item && item.screeningType && item.screeningType._id || item && item.screeningType && item.screeningType.value,
                            eventiveId:item && item.eventiveId ? item.eventiveId : '',
                            maxWaitListSlots:item && item.maxWaitListSlots ? item.maxWaitListSlots : 0,
                            screeningEventiveId: item && item.screeningEventiveId ? item.screeningEventiveId : this.props.film.screnningTypeList[0].eventiveTagId,
                            locationEventiveId: item && item.locationEventiveId,
                            locationType: item && item.locationType && item.locationType._id || item && item.locationType && item.locationType.value,
                            locations: item && item.locations && item.locations.length > 0 ? item.locations.map(e => e.value) : [],
                            accessibility:item?.accessibility?.map(acc => acc.eventiveId),
                            interestTrack:item?.interestTrack?.map(it => it.eventiveId),
                            date: this.getMtTime(item.date),
                            endDate: this.getMtTime(item.endDate),
                            hideFromLive:item.hideFromLive ? item.hideFromLive : false,
                            supressVoting:item.supressVoting ? item.supressVoting : false
                        }
                        if(item.locationType._id === '1' || item.locationType.value === '1'){
                            dateTime.locationCity = item && item.locationCity ? item.locationCity : item.locations && item.locations.length > 0 && item.locations[0].city
                        }
                        return dateTime
                    }
                })
                const markup = this.normalizeDraftHtml(this.state.editorState);
                const markupShort = this.normalizeDraftHtml(this.state.editorStateShort);
                const markupExplicitContent = this.normalizeDraftHtml(this.state.editorStateExplicitContent);
                const markupScreeningMoreInfo = this.normalizeDraftHtml(this.state.editorStateScreeningMoreInfo);

                const shortIntroduction = this.state.shortIntroduction;
                const shortFilms = this.state.shortFilms.map(film => film._id);

                const req = {
                    shortIntroduction,
                    shortFilms,
                }

                var artist = this.state.artist.map((element) => {
                    const markup = this.normalizeDraftHtml(element && element.description);

                    var List = {
                        image: element.image,
                        name: element.name,
                        description: markup.trim(),
                        youtube: element.youtube ? (element.youtube.startsWith('https://') ? element.youtube : 'https://www.' + element.youtube) : element.youtube,
                        instagram: element.instagram ? 'https://www.instagram.com/' + element.instagram : element.instagram,
                        twitter: element.twitter ? 'https://x.com/' + element.twitter : element.twitter,

                    };

                    return List;
                });
                if (this.state.filmId) {
                    let updateCreateFilm = {
                        filmId: this.state.filmId,
                        expectedUpdatedAt: this.state.editStartVersion || undefined,
                        fileMakerId: this.state.fileMakerId,
                        eventiveId: this.state.eventiveId,
                        access: this.state.access && this.state.access.value,
                        title: this.state.title,
                        article: this.state.article,
                        description: markup,
                        shortDescription: markupShort,
                        images: this.state.images,
                        credits: creditsData,
                        year: this.state.year,
                        category: this.state.category && this.state.category.value,
                        awardCategory: this.state.awardCategory && this.state.awardCategory.value,
                        awardSponsorLogo: this.state.awardSponsorLogo,
                        votes: this.state.votes,
                        isExplicitContent: this.state.isExplicitContent,
                        explicitContent: markupExplicitContent,
                        sponsorLogo: this.state.sponsorLogo,
                        screeningMoreInfoTitle: this.state.screeningMoreInfoTitle,
                        screeningMoreInfo: markupScreeningMoreInfo,
                        country: this.state.country,
                        language: this.state.language,
                        runTime: this.state.runTime,
                        website: this.state.website !== '' ? 'https://www.' + this.state.website : this.state.website,
                        contact: this.state.contact,
                        company: this.state.company,
                        genre: genreData,
                        interestTrack: interestTrack,
                        accessibility: accessibilityData,
                        dateTime: this.state.shortFlim === true ? [] : dateTimeDate,
                        shortProgrammeId: this.state.shortProgramme1._id ? this.state.shortProgramme1._id : this.state.shortProgramme1.value,
                        qaReplayLink: this.state.qaReplayLink,
                        teamConnection: [
                            {
                                name: this.state.fullNameFirst,
                                email: this.state.fullEmailFirst
                            },
                            {
                                name: this.state.fullNameSecond,
                                email: this.state.fullEmailSecond
                            }],
                        artist: artist,
                        publicContact: {
                            firstName: this.state.publicContact.firstName,
                            middleName: this.state.publicContact.middleName,
                            lastName: this.state.publicContact.lastName,
                            company: this.state.publicContact.company,
                            publicEmail: this.state.publicContact.publicEmail,
                            website: this.state.publicContact.website !== '' ? 'https://www.' + this.state.publicContact.website : this.state.publicContact.website,
                            phoneNumber: this.state.publicContact.phoneNumber,
                            type: this.state.publicContact.type,
                        },
                        postFestivalContact: {
                            firstName: this.state.postFestivalContact.firstName,
                            middleName: this.state.postFestivalContact.middleName,
                            lastName: this.state.postFestivalContact.lastName,
                            company: this.state.postFestivalContact.company,
                            publicEmail: this.state.postFestivalContact.publicEmail,
                            website: this.state.postFestivalContact.website !== '' ? 'https://www.' + this.state.postFestivalContact.website : this.state.postFestivalContact.website,
                            phoneNumber: this.state.postFestivalContact.phoneNumber,
                            type: this.state.postFestivalContact.type,
                        },
                        ...req
                    }
                    isPreview && delete updateCreateFilm['eventiveId']
                    isPreview ? this.apiserve.sendevent("film|previewfilm", updateCreateFilm) : this.apiserve.sendevent("film|edit", updateCreateFilm);
                } else {
                    let addCreateFilm = {
                        fileMakerId: this.state.fileMakerId,
                        access: this.state.access && this.state.access.value,
                        title: this.state.title,
                        description: markup,
                        article: this.state.article,
                        shortDescription: markupShort,
                        images: this.state.images,
                        credits: creditsData,
                        year: this.state.year,
                        category: this.state.category && this.state.category.value,
                        awardCategory: this.state.awardCategory && this.state.awardCategory.value,
                        awardSponsorLogo: this.state.awardSponsorLogo,
                        votes: this.state.votes,
                        isExplicitContent: this.state.isExplicitContent,
                        explicitContent: markupExplicitContent,
                        sponsorLogo: this.state.sponsorLogo,
                        screeningMoreInfoTitle: this.state.screeningMoreInfoTitle,
                        screeningMoreInfo: markupScreeningMoreInfo,
                        country: this.state.country,
                        language: this.state.language,
                        runTime: this.state.runTime,
                        website: this.state.website !== '' ? 'https://www.' + this.state.website : this.state.website,
                        contact: this.state.contact,
                        company: this.state.company,
                        genre: genreData,
                        interestTrack: interestTrack,
                        accessibility: accessibilityData,
                        dateTime: this.state.shortFlim === true ? [] : dateTimeDate,
                        shortProgrammeId: this.state.shortProgramme1._id,
                        qaReplayLink: this.state.qaReplayLink,
                        teamConnection: [
                            {
                                name: this.state.fullNameFirst,
                                email: this.state.fullEmailFirst
                            },
                            {
                                name: this.state.fullNameSecond,
                                email: this.state.fullEmailSecond
                            }],
                        artist: artist,
                        publicContact: {
                            firstName: this.state.publicContact.firstName,
                            middleName: this.state.publicContact.middleName,
                            lastName: this.state.publicContact.lastName,
                            company: this.state.publicContact.company,
                            publicEmail: this.state.publicContact.publicEmail,
                            website: this.state.publicContact.website !== '' ? 'https://www.' + this.state.publicContact.website : this.state.publicContact.website,
                            phoneNumber: this.state.publicContact.phoneNumber,
                            type: this.state.publicContact.type,
                        },
                        postFestivalContact: {
                            firstName: this.state.postFestivalContact.firstName,
                            middleName: this.state.postFestivalContact.middleName,
                            lastName: this.state.postFestivalContact.lastName,
                            company: this.state.postFestivalContact.company,
                            publicEmail: this.state.postFestivalContact.publicEmail,
                            website: this.state.postFestivalContact.website !== '' ? 'https://www.' + this.state.postFestivalContact.website : this.state.postFestivalContact.website,
                            phoneNumber: this.state.postFestivalContact.phoneNumber,
                            type: this.state.postFestivalContact.type,
                        },
                        ...req
                    }
                    isPreview ? this.apiserve.sendevent("film|previewfilm", addCreateFilm) : this.apiserve.sendevent("film|create", addCreateFilm);
                }

                if(!isPreview){
                    this.state.artist.forEach(artistID => {
                        delete artistID._id
                    });

                    this.state.images.forEach(image => {
                        delete image._id
                    });
                }
            } catch (error) {
                this.setState({
                    messageModal: true,
                    filmDisabled: false,
                })
                this.validator.showMessages();
                this.forceUpdate();
            }
        }
        else {
            this.checkCustomValidation()
            this.setState({
                messageModal: true,
                filmDisabled: false,
            })
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    //Genre Master Call
    genreOption = () => {
        var options = []
        this.props.film && this.props.film.genre && this.props.film.genre.forEach(item => {
            options.push({ value: item._id, label: item.name })
        });
        return options
    }

    //Accessibility Master Call
    accessibilityOption = () => {
        var options = []

        this.props.film && this.props.film.accessibility && this.props.film.accessibility.forEach(item => {
            options.push({ value: item._id, label: item.name, eventiveId:item.eventiveId})
        });
        return options
    }

    //Location Master Call
    locationOption = () => {
        var options = []
        this.props.film && this.props.film.locations && this.props.film.locations.forEach(item => {
            if (item._id !== '934e67c906e26dd0737c')
                options.push({ value: item._id, label: item.name, isSet: item.isSet, city: item.city, state: item.state, locationEventiveId: item.eventiveId, maxWaitListSlots:item?.maxWaitListSlots })
        });
        return options
    }

    //Interest Track Master Call
    interestTrackOption = () => {
        var options = []
        this.props.film && this.props.film.interestTrack && this.props.film.interestTrack.forEach(item => {
            options.push({ value: item._id, label: item.name, eventiveId: item.eventiveId })
        });
        return options
    }

    //Year Call
    getYears = () => {
        var years = ["Select From Below"];
        // var startYear = 2023;
        const startYear = new Date().getFullYear() + 1;
        const year = 1985;

        for (var start = startYear; start >= year; start--) {
            years.push(start.toString());
        }

        return years;
    };

    //Contact Push
    addContactFiled = (item) => {
        var newContact = {
            _id: Math.random(),
            emailPhone: ""
        }
        var oldContact = this.state.contact
        oldContact.push(newContact)
        this.setState({
            contact: oldContact
        }, () => {
            this.markFilmEdited();
        });
    }

    //Contact Remove
    removeContactFiled = (i) => {
        var filteredContact = this.state.contact.filter(_ => _._id !== i)

        this.setState({
            contact: filteredContact
        }, () => {
            this.markFilmEdited();
        });
    }

    onChangeContact = (e, id) => {
        const { name, value } = e.target;
        this.state.contact.forEach(contactList => {
            if (contactList._id === id)
                contactList[name] = value
        });
        this.setState({}, () => {
            this.markFilmEdited();
        })
    };

    //Event Date And Time Push
    addDateAndTime = (item) => {
        const newDateAndTime = {
            _id: Math.random(),
            screeningType: { _id: this.props.film && this.props.film.screeningTypeList1[0].type, name: this.props.film && this.props.film.screeningTypeList1[0].name },
            screeningEventiveId: this.props.film && this.props.film.screeningTypeList1[0].eventiveTagId,
            locations: [],
            locationType: { _id: '1', name: 'In-Person' },
            date: new Date(),
            endDate: new Date(),
            accessibility: [],
            interestTrack: [],
            maxWaitListSlots: 0,
            waitListSlotValid: '',
            hideFromLive: false,
            supressVoting: false,
            start: {
                date: new Date(),
                hours: { value: '7', label: '7' },
                minutes: { value: '30', label: '30' },
                state: { value: 'AM', label: 'AM' }
            },
            end: {
                date: new Date(),
                hours: { value: '8', label: '8' },
                minutes: { value: '30', label: '30' },
                state: { value: 'AM', label: 'AM' }
            },
            premierScreening: {
                waitingRoomTrailerShift72Id: "",
                isSponsor: false,
                sponsorLogo: ""
            },
            Shift72Id: '',
            audioDescriptionShift72Id: "",
            piEarlyAccessShift72Id: '',
            piEarlyAccessAudioShift72Id: '',
            isPIEarlyAccessAudio: false,
            emptyLocationError: '',
            screeningCode: 0,
            passBuckets: [],
        }
        const dateTime = [...this.state.dateTime, newDateAndTime];
        this.setState({
            dateTime,
            isMyLibraryScreen: false
        }, () => {
            this.markFilmEdited();
        });
    }

    //Event Date And Time Remove
    removeDateAndTime = (i) => {
        swal({
            title: "Are you sure?",
            text: "You are about to remove a screening",
            icon: "warning",
            buttons: ['Cancel','Continue'],
            dangerMode: true,
        })
        .then((willDelete) => {
            if (willDelete) {
                var filteredscreening = this.state.dateTime.filter(_ => _._id !== i)
                this.setState({
                    dateTime: filteredscreening
                }, () => {
                    this.markFilmEdited();
                });
            }
        });
    }

    //MeetArtists Push
    addMeetArtists = (item) => {
        var newMeetArtist = {
            _id: Math.random(),
            image: "",
            name: "",
            description: EditorState.createEmpty(),
            youtube: "",
            instagram: "",
            twitter: "",
        }
        var oldMeetArtist = this.state.artist
        oldMeetArtist.push(newMeetArtist)
        this.setState({
            artist: oldMeetArtist
        }, () => {
            this.markFilmEdited();
        });
    }

    //MeetArtists Remove
    removeMeetArtists = (i) => {
        var filterArtist = this.state.artist.filter(_ => _._id !== i)

        this.setState({
            artist: filterArtist
        }, () => {
            this.markFilmEdited();
        });
    }

    handleImageAwardSponsorLogo(e) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {
                this.uploadAwardSponsorLogo.value = ''

                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 10240) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 10MB'
                    })
                    return false;
                }
                if (file && (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                    setTimeout(() => {
                        this.imageUploadAwardSponsorLogo(file, event.target.result);
                    }, 1000)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            })
        }
    }

    imageUploadAwardSponsorLogo = (file, img) => {
        this.setState({ ImagePreloaderAwardSponsorLogo: true })
        var fileSet = commonImage(file,false,'',img,'',STORAGE_PATHS.FILMS.AWARD_SPONSOR_LOGO)
        fileSet.then((value) => {
            this.setState({
                awardSponsorLogo: value,
                ImagePreloaderAwardSponsorLogo: false
            }, () => {
                this.markFilmEdited();
            })
        })
    }

    handleImageSponsorLogo(e) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {
                this.uploadSponsorLogo.value = ''
                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 10240) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 10MB'
                    })
                    return false;
                }
                if (file && (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                    setTimeout(() => {
                        this.imageUploadSponsorLogo(file, event.target.result);
                    }, 1000)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            })
        }
    }

    imageUploadSponsorLogo = (file, img) => {
        this.setState({ ImagePreloaderSponsorLogo: true })
        var fileSet = commonImage(file,false,'',img,'',STORAGE_PATHS.FILMS.FILM_SPONSOR_LOGO)
        fileSet.then((value) => {
            this.setState({
                sponsorLogo: value,
                ImagePreloaderSponsorLogo: false
            }, () => {
                this.markFilmEdited();
            })
        })
    }

    handleCheckIsSponsor = (e, id) => {
        const { checked } = e.target;
        const dateTime = this.state.dateTime.map(element => {
            if (element?.premiereScreeningData?._id === id) {
                return { ...element, isSponsor: checked };
            }
            return element;
        });

        this.setState({
            dateTime,
            premiereScreeningData: {
                premiereScreeningData: {
                    ...this.state.premiereScreeningData.premiereScreeningData,
                    isSponsor: checked,
                }
            }
        }, () => {
            this.markFilmEdited();
        });
    }

    handleChnageWaitingRoom = (e, id) => {
        const { value } = e.target;
        const dateTime = this.state.dateTime.map(element => {
            if (element?.premiereScreeningData?._id === id) {
                return { ...element, waitingRoomTrailerShift72Id: value };
            }
            return element;
        });

        this.setState({
            dateTime,
            premiereScreeningData: {
                premiereScreeningData: {
                    ...this.state.premiereScreeningData.premiereScreeningData,
                    waitingRoomTrailerShift72Id: value,
                }
            }
        }, () => {
            this.markFilmEdited();
        });
    }


    handleCheck = (e, id = '') => {
        const { name, checked } = e.target;
        if (name === 'openCaption') {
            const accessibility = this.props.film && this.props.film.accessibility.filter(_ => _.identifier === 'opencaption')
            const dateTime = this.state.dateTime.map((item) => {
                if (item._id === id) {
                    const openCaption = !item.openCaption;
                    return {
                        ...item,
                        openCaption,
                        accessibility: openCaption ? [accessibility[0].eventiveId] : []
                    };
                }
                return item;
            });
            this.setState({ dateTime }, () => {
                this.markFilmEdited();
            });
        } else if (name === 'hideFromLive') {
            const dateTime = this.state.dateTime.map((item) => {
                if (item._id === id) {
                    return { ...item, hideFromLive: checked };
                }
                return item;
            });
            this.setState({ dateTime }, () => {
                this.markFilmEdited();
            });
        } else if (name === 'supressVoting') {
            const dateTime = this.state.dateTime.map((item) => {
                if (item._id === id) {
                    return { ...item, supressVoting: checked };
                }
                return item;
            });
            this.setState({ dateTime }, () => {
                this.markFilmEdited();
            });
        } else {
            this.updateState({
                [name]: checked
            });
        }
    }

    handleImageMeetArtist(e, id) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {

                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 5120) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 5MB'
                    })
                    return false;
                }
                if (file && (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                    setTimeout(() => {
                        this.imageUploadMeetArtists(file, id, event.target.result);
                    }, 1000)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            })
        }
    }

    imageUploadMeetArtists = (file, id,img) => {
        const imagePreloaderId = `imagePreloader_${id}`
        const newState = { ...this.state }
        newState[imagePreloaderId] = true
        this.setState(newState)
        var fileSet = commonImage(file,false,'',img,'',STORAGE_PATHS.FILMS.MEET_THE_ARTIST)
        fileSet.then((value) => {
            this.state.artist.forEach(image => {
                const imagePreloaderId = `imagePreloader_${id}`
                const newState = { ...this.state }
                newState[imagePreloaderId] = false
                this.setState(newState)
                if (image._id === id) {
                    image.image = value
                }

            });
            this.setState({}, () => {
                this.markFilmEdited();
            })
        });


    };

    onInputChangeMeet = (e, id) => {
        const { name } = e.target;
        let { value } = e.target;
        if (name === 'instagram') value = value.replace('https://www.instagram.com/', '');
        if (name === 'twitter') value = value.replace('https://x.com/', '');
        if (name === 'youtube') value = value.replace('https://www.', '');
        this.state.artist.forEach(element => {
            if (element._id === id) {
                element[name] = value
            }
        });
        this.setState({}, () => {
            this.markFilmEdited();
        })
    }

    onEditorStateChangeDesc = (description, id) => {
        const artistIndex = this.state.artist.findIndex((dataList) => dataList._id === id);
        this.state.artist.forEach((dataList) => {
            if (dataList._id === id) {
                dataList.description = description;
            }
        });

        this.setState({},() => {
            this.markFilmEdited();
            if (artistIndex !== -1) {
                this.validator.showMessageFor(`Description_${artistIndex}`)
            }
        });
    };

    handleChangeDate = (date, id, dateType) => {
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                if (dateType === 'startDate') {
                    event.start.date = date
                    event.date = date
                } else if (dateType === 'endDate') {
                    event.end.date = date
                    event.endDate = date
                }
            }
        });
        this.setState({}, () => {
            this.markFilmEdited();
        })
    }

    handleTimeStartHours = (e, id) => {
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.start.hours = e
            }
        });
        this.setState({}, () => {
            this.markFilmEdited();
        })
    }

    handleTimeStartMin = (e, id) => {
        this.setState({}, () => {
            this.markFilmEdited();
        })
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.start.minutes = e
            }
        });
    }

    handleTimeStartStamps = (e, id) => {
        this.setState({}, () => {
            this.markFilmEdited();
        })
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.start.state = e
            }
        });
    }

    handleTimeEndHours = (e, id) => {
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.end.hours = e
            }
        });
        this.setState({}, () => {
            this.markFilmEdited();
        })
    }

    handleTimeEndMin = (e, id) => {
        this.setState({}, () => {
            this.markFilmEdited();
        })
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.end.minutes = e
            }
        });
    }

    handleTimeEndStamps = (e, id) => {
        this.setState({}, () => {
            this.markFilmEdited();
        })
        this.state.dateTime.forEach(event => {
            if (event._id === id) {
                event.end.state = e
            }
        });
    }

    onChangeScreeningType = (e, id) => {
        const { name, value } = e.target;
        let myLibrary = ['6','7','8','9','10','11','12']
        let isMyLibrary = false
        let screenType = []
        if(myLibrary.includes(value)){
            isMyLibrary = true
            this.setState({isMyLibraryScreen:true})
        } else {
            this.updateState({isMyLibraryScreen:false})
        }
        this.state.dateTime.forEach(screeening => {
            
            if (screeening._id === id) {
                if(isMyLibrary){
                    screeening['locationType'] = { _id: '2', label: 'Online' }
                }
                screeening[name] = { _id: value, label: name }
                screeening['screeningEventiveId'] = name !== 'locationType' ? this.getEventiveTag(screeening.locationType._id,value) : this.getEventiveTag(value,screeening.screeningType._id)
                screeening.shift72Id = ''
                screeening['isMyLibrary'] = myLibrary.includes(value)
                screeening.audioDescriptionShift72Id = ""
                screeening.piEarlyAccessShift72Id = ''
                screeening.piEarlyAccessAudioShift72Id = ''
                screeening.isPIEarlyAccessAudio = false
                screeening.maxWaitListSlots = (value === '5' || value === 5) ? 0 : screeening?.locations.length > 0 ? screeening?.locations[0]?.maxWaitListSlots : screeening?.maxWaitListSlots
                if (((this.state.category.value === '5fb39fe53b70f37b9e8c1335' || this.state.category._id === '5fb39fe53b70f37b9e8c1335') || (this.state.category.value === '5fa7d17c0329c105a039f9f7' || this.state.category._id === '5fa7d17c0329c105a039f9f7')) && (screeening.locationType.value === "2" || screeening.locationType._id === "2")) {
                    screeening.date = new Date('01/19/2023')
                    screeening.start.date = new Date('01/19/2023')
                    screeening.start.hours = { value: '12', label: '12' }
                    screeening.start.minutes = { value: '01', label: '01' }
                    screeening.start.state = { value: 'AM', label: 'AM' }
                }
            }
        });
        this.setState({}, () => {
            this.markFilmEdited();
        })
        this.setState({
            errormyLibrary:false
        })
    };
    onInputWaitList = (e, id) => {
        const { name, value } = e.target;
        this.state.dateTime.forEach(screeening => {
            if (screeening._id === id) {
                screeening[name] = value;
                if(value.length > 3){
                    screeening['waitListSlotValid'] = 'Value cannot exceed 3 characters.'
                } else if(/[a-zA-Z!@#$%^&*()_+\[\]{};':"\\|,.<>\/?\-=]+/.test(value)){
                    screeening['waitListSlotValid'] = 'Value can only include numbers.'
                } else {
                    screeening['waitListSlotValid'] = ''
                }
            }
        });
        this.setState({}, () => {
            this.markFilmEdited();
        })
    }
    audioDescriptionShift72Id = (e, id) => {
        const { name, value } = e.target;
        this.state.dateTime.forEach(screeening => {

            if (screeening._id === id) {
                screeening[name] = value;
            }
        });

        this.setState({}, () => {
            this.markFilmEdited();
        })
    }
    handleCheckAudioDescription = (e, id) => {
        const { name, checked } = e.target;
        this.state.dateTime.forEach(screeening => {

            if (screeening._id === id) {
                screeening[name] = checked;
            }
        });
        this.setState({}, () => {
            this.markFilmEdited();
        })
    }

    handleCheckMyLibraryAudio = (e) => {
        const { name, checked } = e.target;
        this.updateState({
            [name]: checked
        })

    }
    handleChangeLocation = (value, parentId) => {
        console.log('locChange:::',value);
        this.state.dateTime.forEach(screeening => {
            if (screeening._id === parentId) {
                if (value !== null || value && value.length !== 0) screeening.emptyLocationError = ''
                else screeening.emptyLocationError = 'Location is required for all screening times.'
                screeening.locations = value
                screeening.locationEventiveId = value && value[0].locationEventiveId
                screeening.maxWaitListSlots = (screeening?.screeningType?._id !== '5' && screeening?.screeningType?._id !== 5) ? (value && value[0]?.maxWaitListSlots) : 0
                screeening.locationCity = value && value[0] && value[0].city
            }
        });

        this.setState({}, () => {
            this.markFilmEdited();
        })
    }

    onChangeInpersonDropdown = (e, id) => {
        const { name, value } = e.target
        let all_inarray = [...this.state.inPersonArray];

        all_inarray.forEach(item => {
            item.isShow = false
            if (id === item?._id) {
                item.isShow = true
            }
        });
        this.updateState({
            InpersonDropdownVal: e.target.value
        })
    }

    makeOption = (data) => {
        return (
            { value: data, label: data }
        )
    }

    //Credit count
    getCreditCount = () => {
        let num = 0
        this.state.credits.forEach((item, i) => {
            if (this.getCreditLabel(item.creditId) !== 'director' && this.getCreditLabel(item.creditId) !== 'screenwriter' && this.getCreditLabel(item.creditId) !== 'principalcast') {
                num = num + item.creditType.length
            }
        })
        this.setState({
            creditCount:num
        })
        return num
    }

    getActiveCreditLabels = () => {
        const normalized = (this.state.category?.label || '').toLowerCase().replace(/\s+/g, '');
        const isNewFrontier = normalized.includes('newfrontier');
        return isNewFrontier ? (this.props.newFrontier?.creditLabel || []) : (this.props.film?.creditLabel || []);
    }

    getCreditLabel = (ID) => {
        return this.getActiveCreditLabels().find(_ => _._id === ID.value)?.identifier
    }
    
    //Credit Push
    addCredit = (item) => {
        if(this.state.creditCount < 24) {
            var newCredit = {
                _id: Math.random(),
                creditId: {value:'',label:''},
                creditType: [{
                    _id: Math.random(),
                    creditsInsideType: '',
                    creditTypeId:Math.random().toString()
                }]
            }
            var oldCredit = this.state.credits
            oldCredit.push(newCredit)
            this.setState({
                credits: oldCredit
            }, () => {
                this.markFilmEdited();
                this.getCreditCount()
            });
        }
    }

    //Credit Remove
    removeCredit = (i) => {
        var filteredCredit = this.state.credits.filter(_ => _._id !== i)

        this.setState({
            credits: filteredCredit
        }, () => {
            this.markFilmEdited();
            this.getCreditCount()
        });
    }

    addInsideCredit = (item) => {
        var creditType = {
            _id: Math.random(),
            creditsInsideType: '',
            creditTypeId:Math.random().toString()
        }

        this.state.credits.forEach(element => {
            if (element._id === item._id) {
                element.creditType.push(creditType)
            }
        });
        this.setState({}, () => {
            this.markFilmEdited();
            this.getCreditCount()
        })
    }

    removeInsideCredit = (parentId, childId) => {
        let newCredit = this.state.credits
        this.state.credits.forEach(element => {
            if (element._id === parentId) {
                var filterInsideCredit = element.creditType.filter(_ => _._id !== childId);
                element.creditType = filterInsideCredit
            }
        });
        let creditValue = ''
        newCredit.map(credit => {
            let clength = credit.creditType.length
            credit.creditType.map((type, i) => {
                creditValue += type.creditsInsideType
                if (clength !== i + 1) {
                    creditValue += ','
                }
            })
            credit.creditTypeValue = creditValue
            creditValue = ''
        })
        this.setState({}, () => {
            this.markFilmEdited();
            this.getCreditCount()
        });
    }

    onChangeCredit = (e, parentId, childId) => {
        const { name, value } = e.target;

        let newCredit = this.state.credits
        this.state.credits.forEach(creditsList => {
            if (creditsList._id === parentId) {
                creditsList.creditType.forEach(element => {
                    if (element._id === childId) {
                        element[name] = value
                    }
                });
            }
        });
        let creditValue = ''
        newCredit.map(credit => {
            let clength = credit.creditType.length
            credit.creditType.map((type, i) => {
                creditValue += type.creditsInsideType
                if (clength !== i + 1) {
                    creditValue += ','
                }
            })
            credit.creditTypeValue = creditValue
            creditValue = ''
        })

        this.setState({}, () => {
            this.markFilmEdited();
        })
    };

    dropChangeCreditLabel = (e, id, item) => {
        const { name, value } = e.target;
        let checkCredit = this.state.credits.find(_ => _.creditId?.value === value)
        if (!checkCredit) {
            let identifier = ''
            this.getActiveCreditLabels().forEach(label => {
                if (label._id === value) {
                    identifier = label.identifier
                }
            })
    
            this.state.credits.forEach(creditsList => {
                if (creditsList._id === id) {
                    creditsList[name] = { value: value, label: value }
                    creditsList.identifier = identifier
                    creditsList.creditType = creditsList.identifier === "screenwriter" ? creditsList.creditType.length > 3 ? creditsList.creditType.slice(0, 3) : creditsList.creditType : creditsList.identifier === "director" && creditsList.creditType.length > 4 ? creditsList.creditType.slice(0, 4) : creditsList.creditType
                }
            });
            this.setState({}, () => {
                this.markFilmEdited();
                this.getCreditCount()
            })
        }
    }

    onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const { destination, source, type } = result;
        const oldIndex = source.index;
        const newIndex = destination.index;

        if (type.startsWith('CREDIT_NAMES_')) {
            const creditTitleId = destination.droppableId;
            const credits = [...this.state.credits];
            const titleIndex = credits.findIndex(c => c._id.toString() === creditTitleId);
            if (titleIndex === -1) return;
            const creditTypes = [...credits[titleIndex].creditType];
            creditTypes.splice(newIndex, 0, creditTypes.splice(oldIndex, 1)[0]);
            credits[titleIndex] = { ...credits[titleIndex], creditType: creditTypes };
            this.setState({ credits, isFilmEdited: true });
            return;
        }

        const arr = [...this.state.credits];
        if (newIndex >= arr.length) {
            var k = newIndex - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
        const updateArr = [];
        arr.forEach(({ _id }, i) => {
            updateArr.push({
                _id: Math.random(),
                creditId: '',
                creditType: [{
                    _id: Math.random(),
                    creditsInsideType: '',
                    sortIndex: i + 1,
                    creditTypeId:Math.random().toString()
                }]
            });
        });
        this.setState({ isDraggable: true, credits: arr }, () => {
            this.markFilmEdited();
        });
    };

    //Credit Lable Master Call
    creditLabel = () => {
        this.getActiveCreditLabels().forEach(item => this.setState({ creditLabel: [...this.state.creditLabel, item.name] }));
    }

    deleteImagePopup = () => {
        let { sponsorLogo, awardSponsorLogo, images, artist, dateTime } = this.state;

        if (this.state.sponsorLogoDetails) {
            sponsorLogo = '';
        }
        if (this.state.awardSponsorLogoDetails) {
            awardSponsorLogo = '';
        }

        const updatedImages = images.map(image => {
            if (image._id === this.state.deleteImageId) {
                return { ...image, inSite: '' };
            }
            return image;
        });

        const updatedArtist = artist.map(element => {
            if (element._id === this.state.deleteImageId) {
                return { ...element, image: '' };
            }
            return element;
        });

        const updatedDateTime = dateTime.map(element => {
            // Check both properties because of inconsistent naming in the codebase
            if (this.state.premiereScreeningData && 
                this.state.premiereScreeningData.premiereScreeningData && 
                (element?._id === this.state.deleteImageId || element?.premierScreening?._id === this.state.deleteId)) {
                return { 
                    ...element, 
                    sponsorLogo: '',
                    premierScreening: element.premierScreening ? { ...element.premierScreening, sponsorLogo: '' } : element.premierScreening
                };
            }
            return element;
        });

        // Specific fix for premiereScreeningData nested state mutation if it exists
        let updatedPremiereData = this.state.premiereScreeningData;
        if (updatedPremiereData && updatedPremiereData.premiereScreeningData && updatedPremiereData.premiereScreeningData.sponsorLogo) {
            updatedPremiereData = {
                ...updatedPremiereData,
                premiereScreeningData: {
                    ...updatedPremiereData.premiereScreeningData,
                    sponsorLogo: ''
                }
            };
        }

        this.setState({
            sponsorLogo,
            awardSponsorLogo,
            images: updatedImages,
            artist: updatedArtist,
            dateTime: updatedDateTime,
            premiereScreeningData: updatedPremiereData,
            deleteImagePopup: false,
            sponsorLogoDetails: false,
            awardSponsorLogoDetails: false,
            deleteImageId: '',
            deleteId: ''
        }, () => {
            this.markFilmEdited();
        });
    }

    setDeleteImagePopup = (id) => {

        this.setState({
            deleteImagePopup: true,
            deleteId: id
        })
    }

    deleteImage(id) {
        this.setState({
            deleteImagePopup: true,
            deleteImageId: id
        })
    }

    deleteImageSponsor() {
        this.setState({
            deleteImagePopup: true,
            awardSponsorLogoDetails: false,
            sponsorLogoDetails: true,
        })
    }

    deleteImageAwardSponsorLogo() {
        this.setState({
            deleteImagePopup: true,
            awardSponsorLogoDetails: true,
            sponsorLogoDetails: false
        })
    }

    handleImage(e, id) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {
                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 10240) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 10MB'
                    })
                    return false;
                }
                if (file && (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                    setTimeout(() => {
                        this.imageUploadOne(file, id, event.target.result);
                    }, 0)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            })
        }
    }

    imageUploadOne = (file, id, img) => {
        const imagePreloaderId = `imagePreloader_${id}`
        const newState = { ...this.state }
        newState[imagePreloaderId] = true
        this.setState(newState)
        var fileSet = commonImage(file,false,'',img,'',STORAGE_PATHS.FILMS.IMAGES)
        fileSet.then((value) => {
            this.state.images.forEach(image => {
                const imagePreloaderId = `imagePreloader_${id}`
                const newState = { ...this.state }
                newState[imagePreloaderId] = false
                this.setState(newState)
                if (image._id === id) {
                    image.inSite = value
                }
            });
            this.setState({}, () => {
                this.markFilmEdited();
            })
        });
    };

    insideOnchange = (e, id) => {
        const { name, value } = e.target
        this.state.images.forEach(inside => {
            if (inside._id === id) {
                inside.link = value
            }
        });
        this.setState({}, () => {
            this.markFilmEdited();
        })
    }

    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }
    errorMsgPopupOk = () => {
        this.setState({
            errorScreeningPopup: false
        })
        this.props.history.push('/filmlist')
    }

    ScreenToggle = (e) => {
        var panel = e.target.parentNode.closest(".inner_screen").querySelector(".screen_content_outer");
        if (panel && panel.style.maxHeight) {
            panel.style.maxHeight = "";
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
        this.setState({
            screencontent: !this.state.screencontent
        })
    }
    
    closeAdminUser = () => {
        this.setState({
            discardPopup: false,
            deleteImagePopup: false
        });
    };

    discardPopupYes = () => {
        this.props.CurrentTab(0)
        this.props.history.push({
            pathname: "/filmlist",
            callFrom: 0
        });
    };

    HideScreeningModal = () => {
        this.setState({
            screeninfpopup: false
        })
    }

    OpenScreening = (item, index) => {
        this.setState({
            premiereScreeningData: item,
            premiereScreeningIndex: item._id,
        }, () => {
            this.setState({
                screeninfpopup: true
            })
        })
    }

    premierePopUpScreening = (id) => {
        let screeningList = {
            waitingRoomTrailerShift72Id: this.state.premiereScreeningData?.premiereScreeningData?.waitingRoomTrailerShift72Id,
            isSponsor: this.state.premiereScreeningData?.premiereScreeningData?.isSponsor,
            sponsorLogo: this.state.premiereScreeningData?.premiereScreeningData?.sponsorLogo
        }
        this.state.dateTime.map(item => {
            if (id === item._id) {
                item.premiereScreeningData = screeningList
            }
        })
        this.setState({
            premiereScreeningData: screeningList,
            screeninfpopup: false,
        })
    }

    getEventiveTag = (locationType,screeningType) => {
        let screenByType  =[]
        screenByType = this.props.film.screeningTypeList1.filter(screen => (screen.type === screeningType && screen.locationType === locationType))
        return screenByType[0].eventiveTagId
    }
    validLink = (link) => {
        let regex = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
        if(regex.test(link)){
            return link
        } else {
            return '/images/image-placeholder.png'
        }
    }

    imageOnError = (event) => {
        event.currentTarget.src = `/images/image-placeholder.png`;
    };
    handleKeySlider = (e) => {
        if (e.keyCode === 9) { // Check if the pressed key is Tab (key code 9)
            e.preventDefault(); // Prevent the default tab focus behavior
        }
    }

    AddShort = () => {
        const [film = {}] = this.state.shortFilms;
        this.setState({
            shortPopUp: true,
            dropListInside: film,
        })
        this.apiserve.sendevent("film|dropList|short", { programType:'1' });
    }

    HideShortPopUp = () =>{
        this.setState({
            shortPopUp:false,
        })
    }

    shortProgramCheck = (e, item) => {
        if (e.target.checked) {
            this.setState({ dropListInside: item });
        } else {
            this.setState({ dropListInside: {} });
        }
    }

    selectedShortFilm = (e) => {
        e.preventDefault();

        if (this.state.dropListInside && this.state.dropListInside?._id) {
            this.setState({
                shortFilms: [this.state.dropListInside],
            }, () => {
                this.markFilmEdited();
                this.HideShortPopUp();
            });
        }
    }

    onSearchFilter = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        }, () => {
            let data = { programType:'1'};
            if (this.state.searchField.length) {
                data.filter = this.state.searchField
            }
            this.apiserve.sendevent("film|dropList|short", data);
        });
    }

    removeShortProgram = (e) => {
        e.preventDefault();
        this.setState({ dropListInside: {}, shortFilms: [] }, () => {
            this.markFilmEdited();
        });
    }

    render() {

        const { contact, dateTime, credits } = this.state
        const myLibrary = ['6','7','8','9','10','11','12']
        const year = this.getYears();
        var settings = {
            customPaging: function (i) {
                return (
                    <a>{i + 1}</a>
                );
            },
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };

        const hours = [
            { value: '12', label: '12' },
            { value: '1', label: '1' },
            { value: '2', label: '2' },
            { value: '3', label: '3' },
            { value: '4', label: '4' },
            { value: '5', label: '5' },
            { value: '6', label: '6' },
            { value: '7', label: '7' },
            { value: '8', label: '8' },
            { value: '9', label: '9' },
            { value: '10', label: '10' },
            { value: '11', label: '11' },
        ]

        const minutes = [
            { value: '00', label: '00' },
            { value: '05', label: '05' },
            { value: '10', label: '10' },
            { value: '15', label: '15' },
            { value: '20', label: '20' },
            { value: '25', label: '25' },
            { value: '30', label: '30' },
            { value: '35', label: '35' },
            { value: '40', label: '40' },
            { value: '45', label: '45' },
            { value: '50', label: '50' },
            { value: '55', label: '55' },
        ]

        const state = [
            { value: 'AM', label: 'AM' },
            { value: 'PM', label: 'PM' }
        ]
        this.validator.purgeFields();
        
        return (
            <>
                <RecordPresenceBanner
                    activeViewers={this.props.recordViewers}
                    conflict={this.props.recordConflict}
                />
                <div className="fpg_tabcontent pl_15 fpg_create_film">
                    {this.state.loaderFlag ?  <Loader /> : ''}
                    <form>
                        <div className="d_flex d_flex_align_baseline">
                            <div className="tab_col create_left_col ">
                                <div className="left_col">
                                    <div className="d_flex id_media d_flex_align_center">
                                        {this.state.filmId &&
                                            <span className="id_text d_flex d_flex_align_baseline"><label>Media ID: </label> {this.state.mediaId} </span>
                                        }
                                        <div className='d_flex d_flex_align_center eventive_id'>
                                            { this.state.filmId && <><label>Eventive ID: </label>
                                                <div className="field_row mb_0">
                                                    <TextField
                                                        type="text"
                                                        name="filmEventiveId" id="filmEventiveId"
                                                        value={this.state.eventiveId}
                                                        disable={true}
                                                    />
                                                </div></>}
                                        </div>
                                    </div>

                                    {/* My Library First & second Half code */}
                                    <div className="field_row disp_flex" style={{ alignItems: 'center' }}>
                                    </div>

                                    <Slider {...settings} >

                                        {this.state.images &&
                                            this.state.images.map((item, index) => {
                                                const imagePreloaderState = `imagePreloader_${item._id}`
                                                return (
                                                    <div>
                                                        <div className="media_image mb_0 absolute_loader">
                                                            {this.state[imagePreloaderState] ?
                                                                <Loader />
                                                                :
                                                                <img src={item.inSite ? this.apiserve.imageUrl + item.inSite : item.link ? this.validLink(item.link) : '/images/image-placeholder.png'} alt="image" onError={(e) => this.imageOnError(e)} />
                                                            }
                                                            <span className="upload_message">Upload PNG/JPEG of max size of 10MB</span>
                                                            <UploadForm item={item} handleImage={(e) => this.handleImage(e, item._id)} deleteImage={() => this.deleteImage(item._id)} iconDelete={true} />
                                                        </div>
                                                        <div className="field_row">
                                                            <div className="field_input relative">
                                                                <input
                                                                    type="text"
                                                                    placeholder="https://cloudfront.aws.com/sdf2345"
                                                                    name='link'
                                                                    id={item._id}
                                                                    value={item.link}
                                                                    onChange={(e) => this.insideOnchange(e, item._id)}
                                                                    onKeyDown={(e) => this.handleKeySlider(e)}
                                                                />
                                                                <span className="copy_box pointer_auto">
                                                                    <CopyIcon />
                                                                </span>
                                                            </div>
                                                        </div>
                                                        {index === 0 ?
                                                            <span style={{ color: 'red' }}>{this.validator.message('image or link', item.link || item.inSite, 'required|urlValidation')}</span>
                                                            : ''
                                                        }
                                                    </div>
                                                )
                                            })}
                                    </Slider>

                                    <div className="relative  static_pagination">

                                    </div>
                                </div>
                                <div className="credit_section">
                                    <div className="credit_header">
                                        <h5>Credits</h5>
                                    </div>
                                    <div className="create_credit_content">
                                        <DragDropContext onDragEnd={this.onDragEnd}>
                                            <Droppable droppableId="droppable" type="CREDIT_TITLE">
                                                {(provided, snapshot) => (
                                                    <ul {...provided.droppableProps} ref={provided.innerRef} >
                                                        {credits.map((item, index) => {
                                                            return (
                                                                <Draggable
                                                                    key={item._id}
                                                                    draggableId={`'${item._id}'`}
                                                                    index={index}
                                                                >
                                                                    {(provided, snapshot) => (
                                                                        <li className="d_flex d_flex_align_center d_flex_align_start"
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}>
                                                                            <span className="pointer d_flex dragger">
                                                                                <DraggerIcon />
                                                                            </span>
                                                                            <div className="dopdown_add_remove d_flex d_flex_align_center">
                                                                                <p className="action_wrap d_flex d_flex_align_center action_wrap d_flex_justify_end">
                                                                                    {index === 0 ?
                                                                                        <span className="pointer" onClick={this.state.creditCount >= 24 ? '' : () => this.addCredit(item)} style={{cursor: this.state.creditCount >= 24 ? 'not-allowed' : 'pointer'}}>
                                                                                            <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                                        </span>
                                                                                        :
                                                                                        <>
                                                                                            <span className="pointer" onClick={() => this.removeCredit(item._id)}>
                                                                                                <FpgMinusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                                            </span>
                                                                                            <span className="pointer" onClick={() => this.addCredit(item)} style={{cursor: this.state.creditCount >= 24 ? 'not-allowed' : 'pointer'}}>
                                                                                                <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                                            </span>
                                                                                        </>
                                                                                    }
                                                                                </p>
                                                                                <div className="field_row mb_0  no_bg_dropdown">
                                                                                    {this.state.filmId ?
                                                                                        <DropdownMaster
                                                                                            name="creditId"
                                                                                            options={
                                                                                                this.getActiveCreditLabels()
                                                                                            }
                                                                                            onChange={(e) => this.dropChangeCreditLabel(e, item._id)}
                                                                                            value={item && item.creditId && item.creditId.value}
                                                                                            fpgerror={this.validator.message('creditLabel', item.creditId, 'required')}

                                                                                        />
                                                                                        :
                                                                                        <DropdownMaster
                                                                                            name="creditId"
                                                                                            options={
                                                                                                this.getActiveCreditLabels()
                                                                                            }
                                                                                            value={item && item.creditId && item.creditId.value}
                                                                                            onChange={(e) => this.dropChangeCreditLabel(e, item._id, item)}
                                                                                            fpgerror={this.validator.message('creditLabel', item.creditId, 'required')}

                                                                                        />
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <Droppable droppableId={item._id.toString()} type={`CREDIT_NAMES_${item._id}`} direction="vertical">
                                                                                    {(providedInner) => (
                                                                                        <div ref={providedInner.innerRef} {...providedInner.droppableProps}>
                                                                                            {item && item.creditType.map((insideCredit, indsideIndex) => (
                                                                                                <Draggable key={insideCredit._id} draggableId={insideCredit._id.toString()} index={indsideIndex}>
                                                                                                    {(providedName) => (
                                                                                                        <div className="textfield_add_remove d_flex d_flex_align_center" ref={providedName.innerRef} {...providedName.draggableProps}>
                                                                                                            <span className="pointer d_flex dragger mt_0 mr_5" {...providedName.dragHandleProps}>
                                                                                                                <DraggerIcon />
                                                                                                            </span>
                                                                                                            <div className="field_row mb_0">
                                                                                                                <TextField
                                                                                                                    type="text"
                                                                                                                    name="creditsInsideType" id="creditsInsideType"
                                                                                                                    value={insideCredit.creditsInsideType}
                                                                                                                    onChange={(e) => this.onChangeCredit(e, item._id, insideCredit._id)}
                                                                                                                    fpgerror={this.validator.message('creditsInsideType', insideCredit.creditsInsideType, 'required')}
                                                                                                                />
                                                                                                            </div>
                                                                                                            <p className="action_wrap aaaa d_flex d_flex_align_center action_wrap ">
                                                                                                                {indsideIndex === 0 ?
                                                                                                                    <span className="pointer" onClick={((!['director','screenwriter','principalcast'].includes(item.identifier) && this.state.creditCount >= 24) || !item.hasOwnProperty('identifier') || (item.identifier === 'director' ? item.creditType.length >= 4 : item.identifier === 'screenwriter' ? item.creditType.length >= 3 : item.identifier === 'principalcast' && item.creditType.length >= 6)) ? '' : () => this.addInsideCredit(item)} style={{cursor: ((!['director','screenwriter','principalcast'].includes(item.identifier) && this.state.creditCount >= 24) || !item.hasOwnProperty('identifier') || (item.identifier === 'director' ? item.creditType.length >= 4 : item.identifier === 'screenwriter' ? item.creditType.length >= 3 : item.identifier === 'principalcast' && item.creditType.length >= 6)) ? 'not-allowed' : 'pointer'}}>
                                                                                                                        <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                                                    </span>
                                                                                                                    :
                                                                                                                    <>
                                                                                                                        <span className="pointer" onClick={() => this.removeInsideCredit(item._id, insideCredit._id)}>
                                                                                                                            <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                                                        </span>
                                                                                                                        <span className="pointer" onClick={((!['director','screenwriter','principalcast'].includes(item.identifier) && this.state.creditCount >= 24) || !item.hasOwnProperty('identifier') || (item.identifier === 'director' ? item.creditType.length >= 4 : item.identifier === 'screenwriter' ? item.creditType.length >= 3 : item.identifier === 'principalcast' && item.creditType.length >= 6)) ? '' : () => this.addInsideCredit(item)} style={{cursor: ((!['director','screenwriter','principalcast'].includes(item.identifier) && this.state.creditCount >= 24) || !item.hasOwnProperty('identifier') || (item.identifier === 'director' ? item.creditType.length >= 4 : item.identifier === 'screenwriter' ? item.creditType.length >= 3 : item.identifier === 'principalcast' && item.creditType.length >= 6)) ? 'not-allowed' : 'pointer'}}>
                                                                                                                            <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                                                        </span>
                                                                                                                    </>
                                                                                                                }
                                                                                                            </p>
                                                                                                        </div>
                                                                                                    )}
                                                                                                </Draggable>
                                                                                            ))}
                                                                                            {providedInner.placeholder}
                                                                                        </div>
                                                                                    )}
                                                                                </Droppable>
                                                                            </div>
                                                                        </li>
                                                                    )}
                                                                </Draggable>
                                                            )
                                                        })}
                                                        {provided.placeholder}
                                                    </ul>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </div>
                                </div>
                                <div className="credit_section artist_section">
                                    <div className="credit_header">
                                        <h5>Meet The Artist</h5>
                                        <span></span>
                                    </div>
                                    {this.state.artist.map((item, i) => {
                                        const imagePreloaderState = `imagePreloader_${item._id}`
                                        return (
                                            <>
                                                <div className="artist_content d_flex">

                                                    <div className="artist_content_side">
                                                        <div className="d_flex inner_artist">
                                                            <div className="artist_user absolute_loader">
                                                                <div className='artist_img'>
                                                                    {this.state[imagePreloaderState] ?
                                                                        <Loader />
                                                                        :
                                                                        <img src={item.image ? this.apiserve.imageUrl + item.image : '/images/user.png'} alt="image" />
                                                                    }
                                                                    <UploadForm item={item} handleImage={(e) => this.handleImageMeetArtist(e, item._id)} deleteImage={() => this.deleteImage(item._id)} iconDelete={true} />
                                                                </div>
                                                                <label>Max size 5MB</label>
                                                            </div>
                                                            <div className="artist_data">
                                                                <div className="field_row">
                                                                    <TextField
                                                                        type="text"
                                                                        name="name" id="name"
                                                                        value={item.name}
                                                                        onChange={(e) => this.onInputChangeMeet(e, item._id)}
                                                                    />
                                                                </div>
                                                                <div className="field_row">
                                                                    <TextEditor
                                                                        name="description"
                                                                        editorState={item.description}
                                                                        value={item.description}
                                                                        onEditorStateChange={(e) =>
                                                                            this.onEditorStateChangeDesc(
                                                                                e,
                                                                                item._id
                                                                            )}
                                                                    />
                                                                    <span style={{ color: 'red' }}>{this.validator.message(`Description_${i}`, item.description, 'wordLimit:50')}</span>
                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className="field_row horizontal_field">
                                                            <TextField
                                                                label="YouTube Embed Source Link"
                                                                placeholder=""
                                                                type="text"
                                                                name="youtube" id="youtube"
                                                                value={item.youtube}
                                                                onChange={(e) => this.onInputChangeMeet(e, item._id)}
                                                                prefix={true}
                                                            />
                                                        </div>
                                                        <div className="field_row horizontal_field">
                                                            <div className="field_row_inner">
                                                                <label className="mb_0"></label>
                                                                <div className="field_input">
                                                                    <div className="video_wrap">
                                                                        <iframe
                                                                            src={getEmbedUrl(item.youtube ? (item.youtube.startsWith('https://') ? item.youtube : 'https://www.' + item.youtube) : '')}>
                                                                        </iframe>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="field_row horizontal_field">
                                                            <div className="field_row_inner">
                                                                <label className="mb_0 text_right"><InstaIcon /></label>
                                                                <div className="field_input relative">
                                                                    <span className="sd_input_prefix">https://www.instagram.com/</span>
                                                                    <input
                                                                        type="text"
                                                                        name="instagram"
                                                                        id="instagram"
                                                                        value={item.instagram}
                                                                        onChange={(e) => this.onInputChangeMeet(e, item._id)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="field_row horizontal_field">
                                                            <div className="field_row_inner">
                                                                <label className="mb_0 text_right"><TwitterIcon /></label>
                                                                <div className="field_input relative">
                                                                    <span className="sd_input_prefix">https://x.com/</span>
                                                                    <input
                                                                        type="text"
                                                                        name="twitter"
                                                                        id="twitter"
                                                                        value={item.twitter}
                                                                        onChange={(e) => this.onInputChangeMeet(e, item._id)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="artist_action">
                                                        <p className="action_wrap d_flex d_flex_align_center action_wrap ">
                                                            {i === 0 ? (
                                                                <span className="pointer" onClick={() => this.addMeetArtists(item, i)}>
                                                                    <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                </span>
                                                            )
                                                                :
                                                                i >= 3 ? <span className="pointer" onClick={() => this.removeMeetArtists(item._id)}>
                                                                    <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                </span>
                                                                    : (
                                                                        <>
                                                                            <span className="pointer" onClick={() => this.removeMeetArtists(item._id)}>
                                                                                <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                            </span>
                                                                            <span className="pointer" onClick={() => this.addMeetArtists(item, i)}>
                                                                                <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                            </span>
                                                                        </>
                                                                    )
                                                            }
                                                        </p>
                                                    </div>

                                                </div>
                                            </>
                                        )
                                    })
                                    }

                                </div>
                            </div>
                            <div className="tab_col create_feature_col d_flex create_film_form">
                                <div className="d_flex w_100">
                                    <div className="feature_top mt_25">
                                        <div className="fpg_edits_links d_flex d_flex_align_center">
                                        </div>
                                        <p className="feature_text">
                                            <div className="field_row horizontal_field">
                                                <DropdownMaster
                                                    label="Access: "
                                                    options={
                                                        this.props.film && this.props.film.access
                                                    }
                                                    name='access'
                                                    value={this.state.access.value}
                                                    onChange={this.dropChange}
                                                    fpgerror={this.validator.message('access', this.state.access, 'required')}
                                                />
                                            </div>
                                        </p>
                                        <div className="feature_title">

                                            <div className="field_row">
                                                <label>title</label>
                                                <TextField
                                                    type='text'
                                                    name="title" id="title"
                                                    value={this.state.title}
                                                    onChange={this.onInputChange}
                                                    placeholder="This is a film"
                                                />
                                                <span style={{ color: 'red' }}>{this.validator.message('title', this.state.title, 'required')}</span>
                                            </div>
                                            <div className="field_row">
                                                <label>Article</label>
                                                <TextField
                                                    type='text'
                                                    name="article" id="article"
                                                    value={this.state.article}
                                                    onChange={this.onInputChange}
                                                    placeholder="This is a article"
                                                />
                                            </div>
                                            <div className="d_flex">
                                                <div className="field_row editor_wrapper mr_15 detail_description">
                                                    <div className="field_row_inner">
                                                        <label>Long Description (Detail Page)</label>
                                                        <div className="field_input relative">
                                                            <Editor
                                                                wrapperClassName="sd_text_editor"
                                                                editorState={this.state.editorState}
                                                                onEditorStateChange={this.onEditorStateChange}
                                                                toolbar={{
                                                                    blockType: {
                                                                        inDropdown: true,
                                                                        options: ['Normal', 'Blockquote'],
                                                                    },
                                                                    inline: { inDropdown: true },
                                                                    list: {
                                                                        inDropdown: true,
                                                                        options: ['unordered', 'ordered'],
                                                                    },
                                                                    textAlign: { inDropdown: true },
                                                                    link: { inDropdown: true },
                                                                    history: { inDropdown: true },
                                                                    options: ['inline', 'blockType', 'list', 'link', 'textAlign'],
                                                                }}
                                                                editorStyle={{ height: '210px' }}
                                                            />
                                                            <span style={{ color: 'red' }}>{this.validator.message('description', this.state.description, 'required')}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="field_row editor_wrapper">
                                                    <div className="field_row_inner">
                                                        <label>Short Description (Catalog)</label>
                                                        <div className="field_input relative">
                                                            <Editor
                                                                wrapperClassName="sd_text_editor"
                                                                editorState={this.state.editorStateShort}
                                                                onEditorStateChange={this.onEditorStateChangeShort}
                                                                toolbar={{
                                                                    blockType: {
                                                                        inDropdown: true,
                                                                        options: ['Normal', 'Blockquote'],
                                                                    },
                                                                    inline: { inDropdown: true },
                                                                    list: {
                                                                        inDropdown: true,
                                                                        options: ['unordered', 'ordered'],
                                                                    },
                                                                    textAlign: { inDropdown: true },
                                                                    link: { inDropdown: true },
                                                                    history: { inDropdown: true },
                                                                    options: ['inline', 'blockType', 'list', 'link', 'textAlign'],
                                                                }}
                                                                editorStyle={{ height: '210px' }}

                                                            />
                                                        </div>
                                                    </div>
                                                    <span style={{ color: 'red' }}>{this.validator.message('shortDescription', this.state.editorStateShort, 'wordLimit:60')}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="wrap_selection_data">
                                            {!this.state.shortFlim && <div>
                                                <div className="program_header d_flex">
                                                    <h3>Shorts Included in film</h3>
                                                    <span onClick={this.AddShort}>Add Short + </span>
                                                </div>
                                                <div className="program_inner mb_15">
                                                    {
                                                        (this.state?.shortFilms.length > 0) && 
                                                        <ul>
                                                            {
                                                                this.state.shortFilms.map((item) => (
                                                                    <li key={item._id}>
                                                                        <div className="d_flex list_inner d_flex_align_center">
                                                                            <div className="program_contents d_flex">
                                                                                <div className="program_image">
                                                                                    <img 
                                                                                        src={item?.images?.inSite 
                                                                                                ? (this.apiserve.imageUrl + item.images.inSite) 
                                                                                                : item?.images?.link          
                                                                                                    ? item.images.link
                                                                                                    : '/images/image-placeholder.png'
                                                                                            }
                                                                                        alt='Short Film'
                                                                                    />
                                                                                </div>
                                                                                <div className="program_contents_desc">
                                                                                    <h2 className="program_title">{item?.title}</h2>
                                                                                    <p className="program_time">{item?.runTime} min</p>
                                                                                </div>
                                                                            </div>
                                                                            <span className="pointer" onClick={(e) => this.removeShortProgram(e)}>
                                                                                <FpgMinusIcon width="20" height="20" color="#4F4F4F" />
                                                                            </span>
                                                                        </div>
                                                                    </li>
                                                                ))
                                                            }
                                                        </ul>
                                                    }
                                                </div>

                                                <div className="field_row horizontal_field">
                                                    <TextField 
                                                        label="Short Introduction"
                                                        name="shortIntroduction" 
                                                        id="shortIntroduction"
                                                        value={this.state.shortIntroduction}
                                                        onChange={this.onInputChange}
                                                        fpgerror={this.validator.message('shortIntroduction', this.state.shortIntroduction, 'shortIntroduction')}
                                                    />
                                                </div>
                                            </div>}
                                            <div className="data_list">
                                                <div className="field_row horizontal_field">
                                                    <Dropdown
                                                        label="Year"
                                                        name="year"
                                                        options={year}
                                                        value={this.state.year}
                                                        onChange={this.dropChangeCountryYear}
                                                        fpgerror={this.validator.message('year', this.state.year, 'required')}
                                                    />
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <DropdownMaster
                                                        label="Category"
                                                        name="category"
                                                        options={
                                                            this.props.film && this.props.film.category
                                                        }
                                                        value={this.state.category.value}
                                                        onChange={this.dropChange}
                                                        fpgerror={this.validator.message('category', this.state.category, 'required')}
                                                    />
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <TextField label="Country"
                                                        name="country" id="country"
                                                        value={this.state.country}
                                                        onChange={this.onInputChange}
                                                        fpgerror={this.validator.message('country', this.state.country, 'required')}
                                                    />
                                                </div>

                                                <div className="field_row horizontal_field">
                                                    <TextField label="Language"
                                                        name="language" id="language"
                                                        value={this.state.language}
                                                        onChange={this.onInputChange}
                                                    />
                                                </div>

                                                <div className="field_row horizontal_field">
                                                    <div className="field_row_inner">
                                                        <label>Run Time</label>
                                                        <div className="field_input relative run_time_field">
                                                            <div>
                                                                <input
                                                                    type="number"
                                                                    name="runTime"
                                                                    id="runTime"
                                                                    value={this.state.runTime}
                                                                    placeholder=""
                                                                    onChange={this.onInputChange}
                                                                />
                                                                <label>min</label>
                                                            </div>
                                                            <span className="error">{this.validator.message('runTime', this.state.runTime, 'required')}</span>
                                                        </div>
                                                    </div>


                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <TextField label="Company"
                                                        name="company" id="company"
                                                        value={this.state.company}
                                                        onChange={this.onInputChange}
                                                    />

                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <TextField label="Website"
                                                        name="website" id="website"
                                                        value={this.state.website}
                                                        onChange={this.onInputChange}
                                                        prefix={true}
                                                    />
                                                </div>

                                                <div className="textfield_add_remove d_flex d_flex_align_center">
                                                    {contact.map((item, i) => (
                                                        <>
                                                            <div className="field_row">
                                                                <TextField
                                                                    label={i === 0 ? "Contact" : ''}
                                                                    type="text"
                                                                    id={item._id}
                                                                    name='emailPhone'
                                                                    value={item.emailPhone}
                                                                    onChange={(e) => this.onChangeContact(e, item._id)}
                                                                />
                                                            </div>
                                                            <p className="action_wrap d_flex d_flex_align_center action_wrap ">
                                                                {i === 0 ? (
                                                                    <>
                                                                        <span className="pointer" onClick={contact.length >= 8 ? '' : () => this.addContactFiled(item, i)} style={{cursor:contact.length >= 8 ? 'not-allowed' : 'pointer'}}>
                                                                            <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                        </span>
                                                                        <span><AddarrowIcon /></span>
                                                                    </>
                                                                )
                                                                    :
                                                                    (
                                                                        <>
                                                                            <span className="pointer" onClick={() => this.removeContactFiled(item._id)}>
                                                                                <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                            </span>
                                                                            <span className="pointer" onClick={contact.length >= 8 ? '' : () => this.addContactFiled(item, i)} style={{cursor:contact.length >= 8 ? 'not-allowed' : 'pointer'}}>
                                                                                <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                            </span>
                                                                        </>
                                                                    )
                                                                }
                                                            </p>
                                                        </>
                                                    ))}
                                                </div>
                                                <div className="pt_25"></div>
                                                <div className="field_row horizontal_field">
                                                    <div className="field_row_inner">
                                                        <label>Genre</label>
                                                        <div className="select_field relative">
                                                            <Select
                                                                isMulti
                                                                onChange={this.handleChangeGenre}
                                                                options={this.genreOption()}
                                                                value={this.state && this.state.genre}
                                                            />
                                                        </div>
                                                    </div>
                                                    <span className="error select_error">{this.validator.message('genre', this.state.genre, 'required')}</span>
                                                </div>
                                                <div className="pb_15"></div>
                                                <div className="field_row horizontal_field">
                                                    <div className="field_row_inner">
                                                        <label>Interest Tracks</label>
                                                        <div className="select_field relative">
                                                            <Select
                                                                isMulti
                                                                onChange={this.handleChangenInterestTrack}
                                                                options={this.interestTrackOption()}
                                                                value={this.state && this.state.interestTrack}
                                                            />
                                                        </div>
                                                    </div>
                                                    <span className="error select_error">{this.validator.message('interest track', this.state.interestTrack, 'required')}</span>
                                                </div>
                                                <div className="field_row horizontal_field">
                                                    <div className="field_row_inner">
                                                        <label>Accessibility</label>
                                                        <div className="select_field relative">
                                                            <Select
                                                                isMulti
                                                                onChange={this.handleChangenAccessibility}
                                                                options={this.accessibilityOption()}
                                                                value={this.state && this.state.accessibility}

                                                            />
                                                        </div>
                                                    </div>
                                                    <span className="error select_error">{this.validator.message('accessibility', this.state.accessibility, 'required')}</span>
                                                </div>
                                            </div>
                                            <div className="connection_detail">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="wrap_selection_data w_100 mt_0">

                                    <div className=" ">
                                        <h2 className='mt_15 mb_15'>Screenings</h2>  
                                        {this.state.shortFlim === false &&
                                            dateTime.map((item, i) => {
                                                return (
                                                    <>
                                                        <div className="field_row screening_info_row">
                                                            <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center feature_date_time">
                                                                <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                                    <label>Event Start Date & Time (MT)</label>
                                                                    <div className="form_group_countdown">
                                                                        <>
                                                                            <TextField type="text" name="countDownDate"
                                                                                value={moment(item.date).format(
                                                                                    "MM/DD/YYYY"
                                                                                )}
                                                                                placeholder="mm / dd / yyyy"
                                                                            />

                                                                            <span className="calendar_img">
                                                                                <DatePicker
                                                                                    selected={item.date}
                                                                                    onChange={(e) => this.handleChangeDate(e, item._id, 'startDate')}
                                                                                    minDate={moment().toDate()}
                                                                                    placeholder="mm/dd/yyyy"
                                                                                    customInput={
                                                                                        <span className="calendar">
                                                                                            <CalendarIcon />
                                                                                        </span>
                                                                                    }
                                                                                />
                                                                            </span>
                                                                            <Select
                                                                                options={hours}
                                                                                value={item.start.hours}
                                                                                name='hours'
                                                                                placeholder="7"
                                                                                onChange={(e) => this.handleTimeStartHours(e, item._id)} />
                                                                            <Select
                                                                                options={minutes}
                                                                                value={item.start.minutes}
                                                                                name='minutes'
                                                                                placeholder="30"
                                                                                onChange={(e) => this.handleTimeStartMin(e, item._id)} />
                                                                            <Select
                                                                                options={state}
                                                                                value={item.start.state}
                                                                                name='state'
                                                                                placeholder="AM"
                                                                                onChange={(e) => this.handleTimeStartStamps(e, item._id)} />
                                                                        </>
                                                                    </div>
                                                                    <p className="action_wrap d_flex d_flex_align_center action_wrap ">

                                                                        {dateTime.length <= 1 ? (
                                                                            <span className="pointer" onClick={() => this.addDateAndTime(item, i)}>
                                                                                <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                            </span>
                                                                        )
                                                                            :
                                                                            (
                                                                                <>
                                                                                    <span className="pointer" onClick={() => this.removeDateAndTime(item._id)}>
                                                                                        <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                    </span>
                                                                                    <span className="pointer" onClick={() => this.addDateAndTime(item, i)}>
                                                                                        <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                    </span>
                                                                                </>
                                                                            )
                                                                        }
                                                                    </p>

                                                                </div>
                                                            </div>

                                                            {/* endDate */}
                                                            <div className="form_group form_group_input textfield_add_remove d_flex d_flex_align_center feature_date_time">
                                                                <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                                    <label>Event End Date & Time (MT)</label>
                                                                    <div className="form_group_countdown">
                                                                        <>
                                                                            <TextField type="text" name="countDownDate"
                                                                                value={moment(item.endDate).format(
                                                                                    "MM/DD/YYYY"
                                                                                )}
                                                                                placeholder="mm / dd / yyyy"
                                                                            />

                                                                            <span className="calendar_img">
                                                                                <DatePicker
                                                                                    selected={item.endDate}
                                                                                    onChange={(e) => this.handleChangeDate(e, item._id, 'endDate')}
                                                                                    minDate={moment(this.state.dateTime.find((e) => e._id === item._id).start.date).toDate()}
                                                                                    placeholder="mm/dd/yyyy"
                                                                                    customInput={
                                                                                        <span className="calendar">
                                                                                            <CalendarIcon />
                                                                                        </span>
                                                                                    }
                                                                                />
                                                                            </span>
                                                                            <Select
                                                                                options={hours}
                                                                                value={item.end.hours}
                                                                                name='hours'
                                                                                placeholder="7"
                                                                                onChange={(e) => this.handleTimeEndHours(e, item._id)} />
                                                                            <Select
                                                                                options={minutes}
                                                                                value={item.end.minutes}
                                                                                name='minutes'
                                                                                placeholder="30"
                                                                                onChange={(e) => this.handleTimeEndMin(e, item._id)} />
                                                                            <Select
                                                                                options={state}
                                                                                value={item.end.state}
                                                                                name='state'
                                                                                placeholder="AM"
                                                                                onChange={(e) => this.handleTimeEndStamps(e, item._id)} />
                                                                        </>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                          
                                                            <div className="field_row">
                                                                <div className="form_group_inner d_flex mb_0 horizontal_field d_flex_align_center">
                                                                    <label></label>
                                                                    <DropdownMaster
                                                                        name="locationType"
                                                                        onChange={(e) => this.onChangeScreeningType(e, item._id)}
                                                                        value={item && item.locationType && item.locationType._id}
                                                                        options={(item.isMyLibrary || myLibrary.includes(item.screeningType._id)) ? this.state.locationType1 : this.state.locationType}
                                                                    />
                                                                    <>
                                                                            <div className="ml_15">
                                                                                <DropdownMasterScreening
                                                                                    name="screeningType"
                                                                                    onChange={(e) => this.onChangeScreeningType(e, item._id)}
                                                                                    value={item && item.screeningType && item.screeningType._id ? item.screeningType._id : this.props.film && this.props.film.screeningTypeList1[0].type}
                                                                                    options={this.props.film && this.props.film.screeningTypeList1?.filter((e) => e.locationType === item.locationType._id).sort((a,b) => a.sortIndex - b.sortIndex)}
                                                                                    defaultValue={this.props.film && this.props.film.screeningTypeList1?.filter((e) => e.locationType === item.locationType._id)?.sort((a,b) => a.sortIndex - b.sortIndex)?.[0]}
                                                                                />

                                                                            </div>
                                                                    </>
                                                                </div>
                                                            </div>
                                                            <div className="field_row horizontal_field">
                                                                <div className="field_row_inner">
                                                                    <label>Accessibility</label>
                                                                    <div className="select_field relative">
                                                                        <Select
                                                                            isMulti
                                                                            onChange={(e) => this.handleChangenAccessibilityScreening(e, item._id)}
                                                                            options={this.accessibilityOption()}
                                                                            value={item.accessibility}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="field_row horizontal_field">
                                                                <div className="field_row_inner">
                                                                    <label>Interest Tracks</label>
                                                                    <div className="select_field relative">
                                                                        <Select
                                                                            isMulti
                                                                            onChange={(e) => this.handleChangenInterestTrackScreening(e, item._id)}
                                                                            options={this.interestTrackOption()}
                                                                            value={item.interestTrack}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="field_row horizontal_field d_flex">
                                                                <div className="field_row_inner">
                                                                    <label>Hide From Live</label>
                                                                    <div className="relative mt_10">
                                                                        <div className="checkbox_field_row">
                                                                            <div className="checkBox">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id={`hideFromLive_`+i}
                                                                                    name={`hideFromLive`}
                                                                                    checked={item.hideFromLive}
                                                                                    onChange={(e) => this.handleCheck(e, item._id)} />
                                                                                <label for={`hideFromLive_`+i} style={{ width: "auto" }}></label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="field_row_inner">
                                                                    <label>Supress Voting</label>
                                                                    <div className="relative mt_10">
                                                                        <div className="checkbox_field_row">
                                                                            <div className="checkBox">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    id={`supressVoting_`+i}
                                                                                    name={`supressVoting`}
                                                                                    checked={item.supressVoting}
                                                                                    onChange={(e) => this.handleCheck(e, item._id)} />
                                                                                <label for={`supressVoting_`+i} style={{ width: "auto" }}></label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {
                                                                item.locationType._id === "1" || item.locationType._id === "3" || item.locationType.value === "1" || item.locationType.value === "3" ?
                                                                    <>
                                                                        <div className="field_row horizontal_field">
                                                                            <div className="d_flex mb_0 d_flex_align_center">
                                                                                <label></label>
                                                                                <div className="field_row horizontal_field width_265">
                                                                                    <div className="field_row_inner">
                                                                                        <label>Location</label>
                                                                                        <div className="select_field relative">
                                                                                            <Select
                                                                                                isMulti
                                                                                                onChange={(e) => this.handleChangeLocation(e, item._id)}
                                                                                                options={this.locationOption()}
                                                                                                value={item && item.locations}
                                                                                            />
                                                                                        </div>
                                                                                        {(item.locationType._id === "1" || item.locationType._id === "3" || item.locationType.value === "1" || item.locationType.value === "3") && <span className="error srv-validation-message" style={{ color: 'red' }}>{item.emptyLocationError}</span>}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    : ''
                                                            }
                                                            <>
                                                            <div className="field_row horizontal_field">
                                                                {<div className="field_row ">
                                                                    <div className="form_group_shift d_flex mb_0 horizontal_field d_flex_align_center">
                                                                        <span className="id_text d_flex d_flex_align_baseline"><label>Maximum Waitlist Slots :</label>
                                                                            <div className="field_row mb_0">
                                                                                <TextField
                                                                                    type="text"
                                                                                    pattern="[0-9]*"
                                                                                    name="maxWaitListSlots"
                                                                                    id={item._id}
                                                                                    value={item.maxWaitListSlots}
                                                                                    onChange={(e) => this.onInputWaitList(e, item._id)}
                                                                                />
                                                                            </div>
                                                                        </span>
                                                                    </div>
                                                                  <span className='error srv-validation-message' style={{ color: 'red' }}>{item.waitListSlotValid}</span>
                                                                </div>}
                                                            </div>
                                                                <>
                                                                    {/* Shift72 ID    */}
                                                                    <div className="field_row horizontal_field">
                                                                        { this.state.filmId && <div className="field_row ">
                                                                            <div className="form_group_shift d_flex mb_0 horizontal_field d_flex_align_center">
                                                                                <span className="id_text d_flex d_flex_align_baseline"><label>Eventive ID:</label>
                                                                                    <div className="field_row mb_0">
                                                                                        <TextField
                                                                                            type="text"
                                                                                            name="shift72Id"
                                                                                            id={item._id}
                                                                                            value={item.eventiveId}
                                                                                            disable={true}
                                                                                        />
                                                                                    </div>

                                                                                    <span style={{ color: 'red' }}>{this.validator.message('shift72Id', item.eventiveId, 'alpha_num')}</span>
                                                                                </span>
                                                                            </div>
                                                                        </div>}
                                                                    </div>
                                                                </>
                                                            </>
                                                        </div>
                                                    </>
                                                )
                                            }
                                            )
                                        }

                                    </div>

                                    <div className="field_row horizontal_field">
                                        <DropdownMaster
                                            label="Award Category"
                                            name="awardCategory"
                                            options={
                                                this.props.film && this.props.film.awardCategory
                                            }
                                            value={this.state.awardCategory.value}
                                            onChange={this.dropChange}
                                        />
                                    </div>
                                    <span className="error select_error">{this.validator.message('awardCategory', this.state.awardCategory.value, 'required')}</span>
                                    <div className="field_row horizontal_field small_file_upload">
                                        <div className="field_row_inner">
                                            <label>Award Sponsor Logo</label>
                                            <div className="field_input relative">
                                                <div className="media_image mb_0 absolute_loader relative">
                                                    {this.state.ImagePreloaderAwardSponsorLogo ?
                                                        <Loader />
                                                        :
                                                        <img src={this.state.awardSponsorLogo ? this.apiserve.imageUrl + this.state.awardSponsorLogo : '/images/image-placeholder2.png'} alt="image" />
                                                    }
                                                    <div className={`input_file add_input_file ${this.state.awardSponsorLogo ? 'active' : ''}`}>
                                                        <input id="myInput"
                                                            type="file"
                                                            ref={(ref) => this.uploadAwardSponsorLogo = ref}
                                                            style={{ display: 'none' }}
                                                            onChange={this.handleImageAwardSponsorLogo.bind(this)}
                                                            accept=".png, .jpg, .jpeg"
                                                        />
                                                        <span onClick={() => { this.uploadAwardSponsorLogo.click() }}><AddFileIcon /></span>
                                                    </div>
                                                    {this.state.awardSponsorLogo &&
                                                        <span className="remove_file remove_input_file pointer" onClick={() => this.deleteImageAwardSponsorLogo()}><DeletefileIcon /></span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <div className="field_row_inner">
                                            <label>Explicit Content</label>
                                            <div className="relative mt_10">
                                                <div className="checkbox_field_row">
                                                    <div className="checkBox">
                                                        <input
                                                            type="checkbox"
                                                            id="isExplicitContent"
                                                            name="isExplicitContent"
                                                            checked={this.state.isExplicitContent}
                                                            onChange={(e) => this.handleCheck(e)} />
                                                        <label for="isExplicitContent" style={{ width: "auto" }}></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <div className="field_row_inner">
                                            <label>Explicit Content Disclaimer</label>
                                            <div className="field_input relative editor_wrapper">
                                                <Editor
                                                    wrapperClassName="sd_text_editor"
                                                    editorState={this.state.editorStateExplicitContent}
                                                    onEditorStateChange={this.onEditorStateChangeExplicitContent}
                                                    toolbar={{
                                                        blockType: {
                                                            inDropdown: true,
                                                            options: ['Normal', 'Blockquote'],
                                                        },
                                                        inline: { inDropdown: true },
                                                        list: {
                                                            inDropdown: true,
                                                            options: ['unordered', 'ordered'],
                                                        },
                                                        textAlign: { inDropdown: true },
                                                        link: { inDropdown: true },
                                                        history: { inDropdown: true },
                                                        options: ['inline', 'blockType', 'list', 'link', 'textAlign'],

                                                    }}
                                                    editorStyle={{ height: '250px' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field_row horizontal_field small_file_upload">
                                        <div className="field_row_inner">
                                            <label>Film Sponsor Logo</label>
                                            <div className="field_input relative">
                                                <div className="media_image mb_0 absolute_loader relative">
                                                    {this.state.ImagePreloaderSponsorLogo ?
                                                        <Loader />
                                                        :
                                                        <img src={this.state.sponsorLogo ? this.apiserve.imageUrl + this.state.sponsorLogo : '/images/image-placeholder2.png'} alt="image" />
                                                    }
                                                    <div className={`input_file add_input_file ${this.state.sponsorLogo ? 'active' : ''}`}>
                                                        <input id="myInput"
                                                            type="file"
                                                            ref={(ref) => this.uploadSponsorLogo = ref}
                                                            style={{ display: 'none' }}
                                                            onChange={this.handleImageSponsorLogo.bind(this)}
                                                            accept=".png, .jpg, .jpeg"
                                                        />
                                                        <span onClick={() => { this.uploadSponsorLogo.click() }}><AddFileIcon /></span>
                                                    </div>
                                                    {this.state.sponsorLogo &&
                                                        <span className="remove_file remove_input_file pointer" onClick={() => this.deleteImageSponsor()}><DeletefileIcon /></span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <TextField
                                            label="Screening More info Title"
                                            placeholder="Type to lookup sponsor and hit enter to add"
                                            type="text"
                                            name="screeningMoreInfoTitle" id=""
                                            value={this.state.screeningMoreInfoTitle}
                                            onChange={this.onInputChange}
                                        />
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <div className="field_row_inner">
                                            <label>Screening - More Info</label>
                                            <div className="field_input relative editor_wrapper">
                                                <Editor
                                                    wrapperClassName="sd_text_editor"
                                                    editorState={this.state.editorStateScreeningMoreInfo}
                                                    onEditorStateChange={this.onEditorStateChangeScreeningMoreInfo}
                                                    toolbar={{
                                                        blockType: {
                                                            inDropdown: true,
                                                            options: ['Normal', 'Blockquote'],
                                                        },
                                                        inline: { inDropdown: true },
                                                        list: {
                                                            inDropdown: true,
                                                            options: ['unordered', 'ordered'],
                                                        },
                                                        textAlign: { inDropdown: true },
                                                        link: { inDropdown: true },
                                                        history: { inDropdown: true },
                                                        options: ['inline', 'blockType', 'list', 'link', 'textAlign'],

                                                    }}
                                                    editorStyle={{ height: '250px' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field_row horizontal_field pt_15 pb_15 event_link_field event_link_field_qa">
                                        <TextField
                                            label="QA Link"
                                            placeholder="https://video.com"
                                            name="qaReplayLink" id="qaReplayLink"
                                            value={this.state.qaReplayLink}
                                            onChange={this.onInputChange}
                                        />
                                        <span style={{ color: 'red' }}>{this.validator.message('qa Link', this.state.qaReplayLink, 'urlValidation')}</span>
                                    </div>


                                    <div className="pb_25"></div>
                                    <div className="create_connection">
                                        <div className="connection_inner">
                                            <div className="paf_screening_info mt_25 w_100 border_btm_1 pb_25">
                                                <h2 className="paf_screening_info_title mb_10">Film Team - Public Contact Information </h2>
                                                <div className="mb_10">
                                                    <p className="paf_screening_info_subtitle uppercase mb_15">Public Contact (During Festival)</p>
                                                    <div className="pub_contacts">
                                                        <div className="d_flex pub_contacts_firstRow">
                                                            <div className="field_row horizontal_field mr_10">
                                                                <TextField label="First Name" name='firstName' value={this.state.publicContact?.firstName} onChange={this.publicContactChange} maxLength={100} />
                                                            </div>
                                                            <div className="field_row horizontal_field mr_10">
                                                                <TextField label="Middle Name" name='middleName' value={this.state.publicContact?.middleName} onChange={this.publicContactChange} />
                                                            </div>
                                                            <div className="field_row horizontal_field mr_10">
                                                                <TextField label="Last Name" name='lastName' value={this.state.publicContact?.lastName} onChange={this.publicContactChange} maxLength={100} />
                                                            </div>
                                                        </div>
                                                        <div className="d_flex pub_contacts_Row">
                                                            <div className="field_row horizontal_field mr_10">
                                                                <TextField label="Company" name='company' value={this.state.publicContact?.company} onChange={this.publicContactChange} />
                                                            </div>
                                                            <div className="field_row horizontal_field mr_10">
                                                                <TextField label="Public Email" name='publicEmail' value={this.state.publicContact?.publicEmail} onChange={this.publicContactChange} />
                                                            </div>
                                                        </div>
                                                        <div className="d_flex pub_contacts_Row">
                                                            <div className="field_row horizontal_field mr_10">
                                                                <TextField label="Website" name='website' value={this.state.publicContact?.website} onChange={this.publicContactChange} prefix={true} />
                                                            </div>
                                                            <div className="field_row horizontal_field mr_10 team_phone">
                                                                <TextField label="Phone" name='phoneNumber' value={this.state.publicContact?.phoneNumber} onChange={this.publicContactChange} />
                                                            </div>
                                                            <div className="field_row horizontal_field mr_10 team_phone_type">
                                                                <Dropdown label="Phone Type" options={['Office', 'Mobile', 'Other']} name='type' value={this.state.publicContact?.type} onChange={this.publicContactChange} DefaultOption={'Select From Below'} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mb_10">
                                                    <p className="paf_screening_info_subtitle uppercase mb_15">POST FESTIVAL CONTACT (AFTER FESTIVAL)</p>
                                                    <div className="pub_contacts">
                                                        <div className="d_flex pub_contacts_firstRow">
                                                            <div className="field_row horizontal_field mr_10">
                                                                <TextField label="First Name" name='firstName' value={this.state.postFestivalContact?.firstName} onChange={this.postFestivalContactChange} maxLength={100} />
                                                            </div>
                                                            <div className="field_row horizontal_field mr_10">
                                                                <TextField label="Middle Name" name='middleName' value={this.state.postFestivalContact?.middleName} onChange={this.postFestivalContactChange} />
                                                            </div>
                                                            <div className="field_row horizontal_field mr_10">
                                                                <TextField label="Last Name" name='lastName' value={this.state.postFestivalContact?.lastName} onChange={this.postFestivalContactChange} maxLength={100} />
                                                            </div>
                                                        </div>
                                                        <div className="d_flex pub_contacts_Row">
                                                            <div className="field_row horizontal_field mr_10">
                                                                <TextField label="Company" name='company' value={this.state.postFestivalContact?.company} onChange={this.postFestivalContactChange} />
                                                            </div>
                                                            <div className="field_row horizontal_field mr_10">
                                                                <TextField label="Public Email" name='publicEmail' value={this.state.postFestivalContact?.publicEmail} onChange={this.postFestivalContactChange} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="d_flex pub_contacts_Row">
                                                        <div className="field_row horizontal_field mr_10">
                                                            <TextField label="Website" name='website' value={this.state.postFestivalContact?.website} onChange={this.postFestivalContactChange} prefix={true} />
                                                        </div>
                                                        <div className="field_row horizontal_field mr_10 team_phone">
                                                            <TextField label="Phone" name='phoneNumber' value={this.state.postFestivalContact?.phoneNumber} onChange={this.postFestivalContactChange} />
                                                        </div>
                                                        <div className="field_row horizontal_field mr_10 team_phone_type">
                                                            <Dropdown label="Phone Type" options={['Office', 'Mobile', 'Work']} name='type' value={this.state.postFestivalContact?.type} onChange={this.postFestivalContactChange} DefaultOption={'Select From Below'} />
                                                        </div>
                                                    </div>
                                                </div>
                
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div className="text_center field_row w_100 buttons_outer">
                                <button className="uppercase" type='button' onClick={(e) => this.cancelFilmLit(e)}>CANCEL</button>
                                <button className="uppercase prev_btn" type='button' onClick={(e) => this.submitFilm(e, true)}>PREviEW</button>
                                <button className={`uppercase ${(!this.state.filmId || this.state.isFilmEdited) ? 'active' : ''}`} type='button' onClick={(e) => this.submitFilm(e, false)} disabled={this.state.filmDisabled || (this.state.filmId && !this.state.isFilmEdited) ? true : false}>SAVE</button>
                            </div>
                        </div>
                    </form>

                     {
                        this.state.shortPopUp ?
                            <div className='fix_position'>
                                <span className="popup_overlay" onClick={() => this.HideShortPopUp()}> </span>
                                <div className="program_popup" style={{ zIndex:"9999" }}>
                                <div className="program_popup_header d_flex d_flex_justify_spacebt d_flex_align_center">
                                    <span className="header_title">Select Shorts</span>
                                    <div className="relative field_row mb_0">
                                        <div className="field_input">
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                id="searchField"
                                                name="searchField"
                                                value={this.state.searchField}
                                                onChange={this.onSearchFilter} />
                                            <span className="pointer search_icon" type='button' style={{ pointerEvents: 'none' }}><SearchIcon /></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="popup_content" style={{maxHeight:'80vh', overflow: 'auto'}}>
                                    { 
                                        this.state.dropList.map((item) => {
                                            return (
                                                <>
                                                    <div className="customCheckBox">
                                                        <CheckBox name='selectShortFilm'
                                                            value={item.value}
                                                            onChange={(e) => this.shortProgramCheck(e, item)}
                                                            label={item.title}
                                                            type="checkbox"
                                                            id={item.title}
                                                            checked={this.state.dropListInside?._id === item._id}
                                                        />
                                                    </div>
                                                </>
                                            )
                                        })
                                    }
                                </div>


                                <div className="field_row text_center pt_25">
                                    <button onClick={this.HideShortPopUp}> CANCEL</button>
                                    <button className="active" type='button' onClick={(e) => this.selectedShortFilm(e)}>SUBMIT</button>
                                </div>
                            </div>
                            </div>
                            :
                            ""
                    }
                    
                    {this.state.messageModal &&
                        <ModalMessage messageModal={this.state.messageModal} withoutEmail={this.state.errormyLibrary ? 'Film should contain at least one myLibrary Screening' : "Few or all of the required fields are missing. Please scroll up and check to add and confirm and resubmit"} ClosemessageModal={this.ClosemessageModal} />
                    }

                    {this.state.errorPopup ?
                        <ErrorPopUp
                            errorMsg={this.state.errorMsg}
                            errorMsgPopup={this.errorMsgPopup}
                        />
                        : ''
                    }
                    {this.state.errorScreeningPopup ?
                        <ErrorScreeningPopUp
                            errorMsg={this.state.errorData}
                            errorMsgPopup={this.errorMsgPopupOk}
                        />
                        : ''
                    }
                    {this.state.deleteImagePopup ? (
                        <PopUpCustomAll
                            HeaderName="Delete Image?"
                            insideDetails="Are You Sure ?"
                            insideData="You want to delete this image"
                            popupState={this.closeAdminUser}
                            yesPopUp={this.deleteImagePopup}
                        />
                    ) : (
                        ""
                    )}
                    {this.state.discardPopup ? (
                        <PopUpCustomAll
                            HeaderName="Discard Changes?"
                            insideDetails="Leaving this page without saving will discard all changes"
                            insideData="Do you want to proceed?"
                            popupState={this.closeAdminUser}
                            yesPopUp={this.discardPopupYes}
                        />
                    ) : (
                        ""
                    )}
                    <ConflictSaveModal
                        isVisible={this.state.showConflictModal}
                        conflict={this.props.recordConflict}
                        onClose={() => this.setState({ showConflictModal: false })}
                    />
                </div>
            </>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateFilmtab)